{
  "about.blocks": "Servidores suxeitos a moderación",
  "about.contact": "Contacto:",
  "about.default_locale": "Por defecto",
  "about.disclaimer": "Mastodon é software libre, de código aberto, e unha marca comercial de Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Motivo non indicado",
  "about.domain_blocks.preamble": "Mastodon de xeito xeral permíteche ver contidos doutros servidores do fediverso e interactuar coas súas usuarias. Estas son as excepcións que se estabeleceron neste servidor en particular.",
  "about.domain_blocks.silenced.explanation": "Por defecto non verás perfís e contido desde este servidor, a menos que mires de xeito explícito ou optes por seguir ese contido ou usuaria.",
  "about.domain_blocks.silenced.title": "Limitado",
  "about.domain_blocks.suspended.explanation": "Non se procesarán, almacenarán nin intercambiarán datos con este servidor, o que fai imposible calquera interacción ou comunicación coas usuarias deste servidor.",
  "about.domain_blocks.suspended.title": "Suspendido",
  "about.language_label": "Idioma",
  "about.not_available": "Esta información non está dispoñible neste servidor.",
  "about.powered_by": "Comunicación social descentralizada grazas a {mastodon}",
  "about.rules": "Regras do servidor",
  "account.account_note_header": "Nota persoal",
  "account.activity": "Actividade",
  "account.add_note": "Engadir nota persoal",
  "account.add_or_remove_from_list": "Engadir ou eliminar das listaxes",
  "account.badges.admin": "Admin",
  "account.badges.blocked": "Bloqueada",
  "account.badges.bot": "Automatizada",
  "account.badges.domain_blocked": "Dominio bloqueado",
  "account.badges.group": "Grupo",
  "account.badges.muted": "Silenciada",
  "account.badges.muted_until": "Silenciada ate o {until}",
  "account.block": "Bloquear @{name}",
  "account.block_domain": "Bloquear o dominio {domain}",
  "account.block_short": "Bloquear",
  "account.blocked": "Bloqueada",
  "account.cancel_follow_request": "Desbotar a solicitude de seguimento",
  "account.copy": "Copiar ligazón ao perfil",
  "account.direct": "Mencionar de xeito privado a @{name}",
  "account.disable_notifications": "Deixar de notificarme cando @{name} publica",
  "account.edit_note": "Editar a nota persoal",
  "account.edit_profile": "Editar perfil",
  "account.edit_profile_short": "Editar",
  "account.enable_notifications": "Noficarme cando @{name} publique",
  "account.endorse": "Amosar no perfil",
  "account.familiar_followers_many": "Seguida por {name1}, {name2}, e {othersCount, plural, one {outra conta que coñeces} other {outras # contas que coñeces}}",
  "account.familiar_followers_one": "Seguida por {name1}",
  "account.familiar_followers_two": "Seguida por {name1} e {name2}",
  "account.featured": "Destacado",
  "account.featured.accounts": "Perfís",
  "account.featured.collections": "Coleccións",
  "account.featured.new_collection": "Nova colección",
  "account.field_overflow": "Mostrar contido completo",
  "account.filters.all": "Toda actividade",
  "account.filters.boosts_toggle": "Mostrar promocións",
  "account.filters.posts_boosts": "Publicacións e promocións",
  "account.filters.posts_only": "Publicacións",
  "account.filters.posts_replies": "Publicacións e respostas",
  "account.filters.replies_toggle": "Mostrar respostas",
  "account.follow": "Seguir",
  "account.follow_back": "Seguir tamén",
  "account.follow_back_short": "Seguir tamén",
  "account.follow_request": "Solicitar seguir",
  "account.follow_request_cancel": "Desbotar a petición",
  "account.follow_request_cancel_short": "Desbotar",
  "account.follow_request_short": "Solicitar",
  "account.followers": "Seguidoras",
  "account.followers.empty": "Aínda ninguén segue esta usuaria.",
  "account.followers_counter": "{count, plural, one {{counter} seguidora} other {{counter} seguidoras}}",
  "account.followers_you_know_counter": "{counter} que coñeces",
  "account.following": "Seguindo",
  "account.following_counter": "{count, plural, one {{counter} seguimento} other {{counter} seguimentos}}",
  "account.follows.empty": "Esta usuaria aínda non segue a ninguén.",
  "account.follows_you": "Séguete",
  "account.go_to_profile": "Ir ao perfil",
  "account.hide_reblogs": "Agochar promocións de @{name}",
  "account.in_memoriam": "Lembranzas.",
  "account.join_modal.day": "Día",
  "account.join_modal.me": "Unícheste a {server} o",
  "account.join_modal.me_anniversary": "Feliz Fediversario! Chegaches a {server} o",
  "account.join_modal.me_today": "É o teu primeiro día en {server}!",
  "account.join_modal.other": "{name} uníuse a {server} o",
  "account.join_modal.other_today": "É o primeiro día de {name} en {server}!",
  "account.join_modal.share.celebrate": "Comparte unha mensaxe de celebración",
  "account.join_modal.share.intro": "Comparte unha mensaxe de presentación",
  "account.join_modal.share.welcome": "Comparte unha mensaxe de benvida",
  "account.join_modal.years": "{number, plural, one {ano} other {anos}}",
  "account.joined_short": "Uniuse",
  "account.languages": "Modificar os idiomas subscritos",
  "account.last_active": "Última actividade",
  "account.link_verified_on": "A propiedade desta ligazón foi verificada o {date}",
  "account.locked_info": "Esta é unha conta privada. A propietaria revisa de xeito manual quen pode seguila.",
  "account.media": "Multimedia",
  "account.mention": "Mencionar @{name}",
  "account.menu.add_to_list": "Engadir á lista…",
  "account.menu.block": "Bloquear conta",
  "account.menu.block_domain": "Bloquear a {domain}",
  "account.menu.copied": "Copiouse a ligazón á conta no portapapeis",
  "account.menu.copy": "Copiar ligazón",
  "account.menu.direct": "Mención privada para",
  "account.menu.hide_reblogs": "Ocultar as promocións na cronoloxía",
  "account.menu.mention": "Mencionar a",
  "account.menu.mute": "Silenciar conta",
  "account.menu.note.description": "Só ti podes vela",
  "account.menu.open_original_page": "Ver en {domain}",
  "account.menu.remove_follower": "Quitar seguidora",
  "account.menu.report": "Denunciar conta",
  "account.menu.share": "Compartir…",
  "account.menu.show_reblogs": "Ver promocións na cronoloxía",
  "account.menu.unblock": "Desbloquear conta",
  "account.menu.unblock_domain": "Desbloquear a {domain}",
  "account.menu.unmute": "Retirar silencio da conta",
  "account.moved_to": "{name} informa de que a súa nova conta é:",
  "account.mute": "Acalar @{name}",
  "account.mute_notifications_short": "Silenciar notificacións",
  "account.mute_short": "Acalar",
  "account.muted": "Acalada",
  "account.mutual": "Seguimento mútuo",
  "account.name.copy": "Copiar identificador",
  "account.name.help.domain": "{domain} é o servidor que aloxa o perfil e as publicacións da usuaria.",
  "account.name.help.domain_self": "{domain} é o servidor que aloxa o teu perfil e publicacións.",
  "account.name.help.footer": "Do mesmo xeito que podes enviar un correo electrónico a unha persoa que utiliza outro provedor, podes relacionarte con persoas doutros servidores Mastodon, e con calquera que use as outras apps do Fediverso.",
  "account.name.help.header": "Un alcume é o como o enderezo de correo",
  "account.name.help.username": "{username} é o nome de usuaria da conta no seu servidor. Alguén noutro servidor podería ter o mesmo nome de usuaria.",
  "account.name.help.username_self": "{username} é o teu nome de usuaria nete servidor. Alguén noutro sevidor podería ter o mesmo nome de usuaria.",
  "account.name_info": "Isto que significa?",
  "account.no_bio": "Sen descrición.",
  "account.node_modal.callout": "As notas persoais só as podes ver ti.",
  "account.node_modal.edit_title": "Editar nota persoal",
  "account.node_modal.error_unknown": "Non se puido gardar a nota",
  "account.node_modal.field_label": "Nota persoal",
  "account.node_modal.save": "Gardar",
  "account.node_modal.title": "Engadir nota persoal",
  "account.note.edit_button": "Editar",
  "account.note.title": "Nota persoal (só ti podes vela)",
  "account.open_original_page": "Abrir páxina orixinal",
  "account.pending": "Pendente",
  "account.posts": "Publicacións",
  "account.remove_from_followers": "Retirar a {name} das seguidoras",
  "account.report": "Informar sobre @{name}",
  "account.requested_follow": "{name} solicitou seguirte",
  "account.share": "Compartir o perfil de @{name}",
  "account.show_reblogs": "Amosar compartidos de @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} publicación} other {{counter} publicacións}}",
  "account.timeline.pinned": "Fixadas",
  "account.timeline.pinned.view_all": "Ver todas as publicacións fixadas",
  "account.unblock": "Desbloquear @{name}",
  "account.unblock_domain": "Amosar {domain}",
  "account.unblock_domain_short": "Desbloquear",
  "account.unblock_short": "Desbloquear",
  "account.unendorse": "Non amosar no perfil",
  "account.unfollow": "Deixar de seguir",
  "account.unmute": "Deixar de silenciar a @{name}",
  "account.unmute_notifications_short": "Reactivar notificacións",
  "account.unmute_short": "Non silenciar",
  "account_edit.advanced_settings.bot_hint": "Advirte ás usuarias de que esta conta realiza principalmente accións automatizadas e podería non estar monitorizada",
  "account_edit.advanced_settings.bot_label": "Conta automatizada",
  "account_edit.advanced_settings.title": "Axustes avanzados",
  "account_edit.bio.add_label": "Engadir biografía",
  "account_edit.bio.edit_label": "Editar biografía",
  "account_edit.bio.placeholder": "Escribe unha breve presentación para que te coñezan mellor.",
  "account_edit.bio.title": "Sobre ti",
  "account_edit.bio_modal.add_title": "Engadir biografía",
  "account_edit.bio_modal.edit_title": "Editar biografía",
  "account_edit.column_button": "Feito",
  "account_edit.column_title": "Editar perfil",
  "account_edit.custom_fields.add_label": "Engadir un campo",
  "account_edit.custom_fields.edit_label": "Edita o campo",
  "account_edit.custom_fields.placeholder": "Engade os teus pronomes, ligazóns externas, ou o que queiras compartir.",
  "account_edit.custom_fields.reorder_button": "Reordenar os campos",
  "account_edit.custom_fields.tip_content": "Podes darlle maior credibilidade á túa conta Mastodon se verificas as ligazóns a sitios web da túa propiedade.",
  "account_edit.custom_fields.tip_title": "Consello: Engadir ligazóns verificadas",
  "account_edit.custom_fields.title": "Campos personalizados",
  "account_edit.custom_fields.verified_hint": "Como engado unha ligazón verificada?",
  "account_edit.display_name.add_label": "Engadir nome público",
  "account_edit.display_name.edit_label": "Editar o nome público",
  "account_edit.display_name.placeholder": "O nome público é o nome que aparece no perfil e nas cronoloxías.",
  "account_edit.display_name.title": "Nome público",
  "account_edit.featured_hashtags.edit_label": "Engadir cancelos",
  "account_edit.featured_hashtags.placeholder": "Facilita que te identifiquen, e da acceso rápido aos teus intereses favoritos.",
  "account_edit.featured_hashtags.title": "Cancelos destacados",
  "account_edit.field_actions.delete": "Eliminar campo",
  "account_edit.field_actions.edit": "Edita o campo",
  "account_edit.field_delete_modal.confirm": "Tes certeza de querer eliminar este campo persoal? A acción non se pode desfacer.",
  "account_edit.field_delete_modal.delete_button": "Eliminar",
  "account_edit.field_delete_modal.title": "Eliminar campo persoal?",
  "account_edit.field_edit_modal.add_title": "Engadir campo persoal",
  "account_edit.field_edit_modal.discard_confirm": "Desbotar",
  "account_edit.field_edit_modal.discard_message": "Tes cambios sen gardar. Tes certeza de querer desbotalos?",
  "account_edit.field_edit_modal.edit_title": "Editar campo persoal",
  "account_edit.field_edit_modal.length_warning": "Superouse o límite de caracteres recomendado. Nos móbiles podería non verse o campo completo.",
  "account_edit.field_edit_modal.link_emoji_warning": "Non recomendamos o uso de emojis persoais combinados con URLs. Os campos persoais que conteñen ambos móstranse só como texto e non como unha ligazón, para evitar a confusión de quen os lea.",
  "account_edit.field_edit_modal.name_hint": "Ex. \"Páxina web persoal\"",
  "account_edit.field_edit_modal.name_label": "Etiqueta",
  "account_edit.field_edit_modal.url_warning": "Para engadir unha ligazón, inclúe {protocol} diante.",
  "account_edit.field_edit_modal.value_hint": "Ex. “https://exemplo.me”",
  "account_edit.field_edit_modal.value_label": "Valor",
  "account_edit.field_reorder_modal.drag_cancel": "Cancelouse o arrastrado. Soltouse o campo \"{item}\".",
  "account_edit.field_reorder_modal.drag_end": "Soltouse o campo \"{item}\".",
  "account_edit.field_reorder_modal.drag_instructions": "Para ordear os campos persoais, preme espazo ou enter. Ao arrastrar, usa as teclas de frecha para mover o campo arriba ou abaixo. Preme espazo ou enter outra vez para soltar o campo na nova posición, ou preme escape para cancelar.",
  "account_edit.field_reorder_modal.drag_move": "Moveuse o campo \"{item}\".",
  "account_edit.field_reorder_modal.drag_over": "Moveuse o campo \"{item}\" enriba de \"{over}\".",
  "account_edit.field_reorder_modal.drag_start": "Seleccionado o campo \"{item}\".",
  "account_edit.field_reorder_modal.handle_label": "Arrastra o campo \"{item}\"",
  "account_edit.field_reorder_modal.title": "Ordear campos",
  "account_edit.image_alt_modal.add_title": "Engadir texto descritivo",
  "account_edit.image_alt_modal.details_content": "COMO: <ul> <li>Descríbete como apareces na imaxe</li> <li>Usa a terceira persoa (ex. “Alex”, e non “eu”)</li> <li>Sé breve – abondan poucas palabras</li> </ul> NON fagas: <ul> <li>Comezar con “Foto de” – é redundante nos lectores de pantalla</li> </ul> EXEMPLO: <ul> <li>“Alex vestindo camisa verde e cos lentes postos”</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Consellos: Texto descritivo para fotos de perfil",
  "account_edit.image_alt_modal.edit_title": "Editar descrición",
  "account_edit.image_alt_modal.text_hint": "A descrición axuda ás persoas que usan lectores de pantalla a comprender o que publicas.",
  "account_edit.image_alt_modal.text_label": "Texto descritivo",
  "account_edit.image_delete_modal.confirm": "Tes certeza de querer eliminar esta imaxe? Non se poderá desfacer a acción.",
  "account_edit.image_delete_modal.delete_button": "Eliminar",
  "account_edit.image_delete_modal.title": "Eliminar imaxe?",
  "account_edit.image_edit.add_button": "Engadir imaxe",
  "account_edit.image_edit.alt_add_button": "Engadir descrición",
  "account_edit.image_edit.alt_edit_button": "Editar descrición",
  "account_edit.image_edit.remove_button": "Retirar a imaxe",
  "account_edit.image_edit.replace_button": "Substituír a imaxe",
  "account_edit.item_list.delete": "Eliminar {name}",
  "account_edit.item_list.edit": "Editar {name}",
  "account_edit.name_modal.add_title": "Engadir nome público",
  "account_edit.name_modal.edit_title": "Editar o nome público",
  "account_edit.profile_tab.button_label": "Personalizar",
  "account_edit.profile_tab.hint.description": "Estes axustes personalizan o que ven as usuarias de {server} nas apps oficiais, pero non se aplica ás usuarias de outros servidores nin apps alleas.",
  "account_edit.profile_tab.hint.title": "A aparencia pode variar",
  "account_edit.profile_tab.show_featured.description": "'Destacado' é unha pestana optativa na que podes mostrar outras contas.",
  "account_edit.profile_tab.show_featured.title": "Mostrar pestana 'Destacado'",
  "account_edit.profile_tab.show_media.description": "'Multimedia' é unha pestana optativa na que aparecen as túas publicacións con fotos e vídeos.",
  "account_edit.profile_tab.show_media.title": "Mostrar pestana 'Multimedia'",
  "account_edit.profile_tab.show_media_replies.description": "Ao activala, a pestana Multimedia mostra tanto as túas publicacións como as respostas a outras persoas.",
  "account_edit.profile_tab.show_media_replies.title": "Incluír respostas na pestana 'Multimedia'",
  "account_edit.profile_tab.show_relations.description": "Mostra no teu perfil as contas que segues e que te seguen desde outros servidores. Outras persoas poderán ver se as estás a seguir.",
  "account_edit.profile_tab.show_relations.title": "Mostrar 'Seguidoras' e 'Seguimentos'",
  "account_edit.profile_tab.subtitle": "Personaliza como se mostra o teu perfil.",
  "account_edit.profile_tab.title": "Axustes de aparencia do perfil",
  "account_edit.save": "Gardar",
  "account_edit.upload_modal.back": "Volver",
  "account_edit.upload_modal.done": "Feito",
  "account_edit.upload_modal.next": "Seguinte",
  "account_edit.upload_modal.step_crop.zoom": "Achegamento",
  "account_edit.upload_modal.step_upload.button": "Explorar ficheiros",
  "account_edit.upload_modal.step_upload.dragging": "Solta aquí para subir",
  "account_edit.upload_modal.step_upload.header": "Escoller unha imaxe",
  "account_edit.upload_modal.step_upload.hint": "Formato WEBP, PNG, GIF ou JPG, ata {limit}MB.{br}A imaxe será comprimida a {width}x{height}px.",
  "account_edit.upload_modal.title_add.avatar": "Engadir foto do perfil",
  "account_edit.upload_modal.title_add.header": "Engadir foto da cabeceira",
  "account_edit.upload_modal.title_replace.avatar": "Substituír foto do perfil",
  "account_edit.upload_modal.title_replace.header": "Substituír foto da cabeceira",
  "account_edit.verified_modal.details": "Engade maior credibilidade ao teu perfil Mastodon verificando as ligazóns ás túas páxinas web persoais. Funciona así:",
  "account_edit.verified_modal.invisible_link.details": "Engade a ligazón ao «header» da páxina web. A parte importante é rel=\"me\", que evita a suplantación en sitios web con contido creado polas usuarias. Tamén podes usar a etiqueta «link» na cabeceira da páxina no lugar de {tag}, pero o HTML ten que ser accesible sen usar JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "Como fago visible a ligazón?",
  "account_edit.verified_modal.step1.header": "Copia o código HTML inferior e pégao no «header» da túa páxina web",
  "account_edit.verified_modal.step2.details": "Se xa engadiches a túa páxina a un dos campos persoais terás que eliminalo e volvelo a engadir para realizar a verificación.",
  "account_edit.verified_modal.step2.header": "Engade a túa páxina como campo persoal",
  "account_edit.verified_modal.title": "Como engadir unha ligazón verificada",
  "account_edit_tags.add_tag": "Engadir #{tagName}",
  "account_edit_tags.column_title": "Editar etiquetas",
  "account_edit_tags.help_text": "Os cancelos destacados axúdanlle ás usuarias a atopar e interactuar co teu perfil. Aparecen como filtros na túa páxina de perfil na vista Actividade.",
  "account_edit_tags.max_tags_reached": "Acadaches o número máximo de cancelos destacados.",
  "account_edit_tags.search_placeholder": "Escribe un cancelo…",
  "account_edit_tags.suggestions": "Suxestións:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# publicación} other {# publicacións}}",
  "account_list.hidden_notice": "Isto só o ves ti. Para que sexa visible por outras persoas vai a  <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# conta} other {# contas}}",
  "account_note.placeholder": "Preme para engadir nota",
  "admin.dashboard.daily_retention": "Ratio de retención de usuarias diaria após rexistrarse",
  "admin.dashboard.monthly_retention": "Ratio de retención de usuarias mensual após o rexistro",
  "admin.dashboard.retention.average": "Media",
  "admin.dashboard.retention.cohort": "Mes de rexistro",
  "admin.dashboard.retention.cohort_size": "Novas usuarias",
  "admin.impact_report.instance_accounts": "Perfís que isto eliminaría",
  "admin.impact_report.instance_followers": "As seguidoras que perderían as nosas usuarias",
  "admin.impact_report.instance_follows": "As seguidoras que as súas usuarias perderían",
  "admin.impact_report.title": "Resumo das consecuencias",
  "alert.rate_limited.message": "Téntao novamente após {retry_time, time, medium}.",
  "alert.rate_limited.title": "Límite de intentos",
  "alert.unexpected.message": "Aconteceu un fallo non agardado.",
  "alert.unexpected.title": "Vaites!",
  "alt_text_badge.title": "Texto Alt",
  "alt_text_modal.add_alt_text": "Engadir texto descritivo",
  "alt_text_modal.add_text_from_image": "Engadir texto desde a imaxe",
  "alt_text_modal.cancel": "Desbotar",
  "alt_text_modal.change_thumbnail": "Cambiar a miniatura",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Describe isto para as persoas con dificultades auditivas…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Describe isto para as persoas con dificultades visuais…",
  "alt_text_modal.done": "Feito",
  "announcement.announcement": "Anuncio",
  "annual_report.announcement.action_build": "Crear o meu Wrapstodon",
  "annual_report.announcement.action_dismiss": "Non, grazas",
  "annual_report.announcement.action_view": "Ver o meu Wrapstodon",
  "annual_report.announcement.description": "Olla o que andiveches facendo en Mastodon durante o último ano.",
  "annual_report.announcement.title": "Chegou o Wrapstodon de {year}",
  "annual_report.nav_item.badge": "Novidade",
  "annual_report.shared_page.donate": "Doar",
  "annual_report.shared_page.footer": "Creado con {heart} polo equipo de Mastodon",
  "annual_report.shared_page.footer_server_info": "{username} utiliza {domain}, unha das moitas comunidades de Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} á caza de publicacións para promover, dando relevancia a outras creadoras.",
  "annual_report.summary.archetype.booster.desc_self": "Á caza de publicacións para promover, dando relevancia a outras creadoras.",
  "annual_report.summary.archetype.booster.name": "Arqueire",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Sabemos que {name} andivo por aí, nalgures, desfrutando de Mastodon paseniño e ao seu xeito.",
  "annual_report.summary.archetype.lurker.desc_self": "Sabemos que andiveches por aí, nalgures, desfrutando de Mastodon tranquilamente e ao teu xeito.",
  "annual_report.summary.archetype.lurker.name": "Xubilade",
  "annual_report.summary.archetype.oracle.desc_public": "{name} creou máis publicacións que respostas, mantendo Mastodon ao día e ollando ao futuro.",
  "annual_report.summary.archetype.oracle.desc_self": "Creaches máis publicacións que respostas, mantendo Mastodon ao día e ollando o futuro.",
  "annual_report.summary.archetype.oracle.name": "O Oráculo",
  "annual_report.summary.archetype.pollster.desc_public": "{name} creou máis enquisas que publicacións normais, cultivando a curiosidade en Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Creaches máis enquisas que publicacións normais, cultivando a curiosidade en Mastodon.",
  "annual_report.summary.archetype.pollster.name": "O mar de dúbidas",
  "annual_report.summary.archetype.replier.desc_public": "{name} respondeu con frecuencia a outras persoas, polinizando Mastodon con novas conversas.",
  "annual_report.summary.archetype.replier.desc_self": "Respondeches con frecuencia a outras persoas, polinizando Mastodon con novas conversas.",
  "annual_report.summary.archetype.replier.name": "A Bolboreta",
  "annual_report.summary.archetype.reveal": "Mostrar o meu arquetipo",
  "annual_report.summary.archetype.reveal_description": "Grazas por ser parte de Mastodon! É hora de coñecer o teu arquetipo de usuaria no {year}.",
  "annual_report.summary.archetype.title_public": "Arquetipo de {name}",
  "annual_report.summary.archetype.title_self": "O teu arquetipo",
  "annual_report.summary.close": "Fechar",
  "annual_report.summary.copy_link": "Copiar ligazón",
  "annual_report.summary.followers.new_followers": "{count, plural, one {nova seguidora} other {nevas seguidoras}}",
  "annual_report.summary.highlighted_post.boost_count": "Esta publicación promoveuse {count, plural, one {unha vez} other {# veces}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Esta publicación favoreceuse {count, plural, one {unha vez} other {# veces}}.",
  "annual_report.summary.highlighted_post.reply_count": "Esta publicación tivo {count, plural, one {unha resposta} other {# respostas}}.",
  "annual_report.summary.highlighted_post.title": "Publicación máis popular",
  "annual_report.summary.most_used_app.most_used_app": "app que mais usaches",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "o cancelo mais utilizado",
  "annual_report.summary.most_used_hashtag.used_count": "Incluíches este cancelo en {count, plural, one {1 publicación} other {# publicacións}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} incluíu este cancelo en {count, plural, one {1 publicación} other {# publicacións}}.",
  "annual_report.summary.new_posts.new_posts": "novas publicacións",
  "annual_report.summary.percentile.text": "<topLabel>Sitúante no top</topLabel><percentage></percentage><bottomLabel> das usuarias de {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Moito tes que contarnos!",
  "annual_report.summary.share_elsewhere": "Compárteo onde queiras",
  "annual_report.summary.share_message": "Resulta que son… {archetype}!",
  "annual_report.summary.share_on_mastodon": "Compartir en Mastodon",
  "attachments_list.unprocessed": "(sen procesar)",
  "audio.hide": "Agochar audio",
  "block_modal.no_collections": "Ninguén de vós poderá engadir á outra a coleccións. Ides ser retiradas automaticamente das coleccións relativas existentes, se fose o caso.",
  "block_modal.remote_users_caveat": "Ímoslle pedir ao servidor {domain} que respecte a túa decisión. Emporiso, non hai garantía de que atenda a petición xa que os servidores xestionan os bloqueos de formas diferentes. As publicacións públicas poderían aínda ser visibles para usuarias que non iniciaron sesión.",
  "block_modal.show_less": "Mostrar menos",
  "block_modal.show_more": "Mostrar máis",
  "block_modal.they_cant_mention": "Non podedes mencionarvos, seguirvos ou citarvos unha á outra.",
  "block_modal.they_cant_see_posts": "Non pode ver os teus contidos nin ti ver os da outra persoa.",
  "block_modal.they_will_know": "Pode ver que a bloqueaches.",
  "block_modal.title": "Bloquear usuaria?",
  "block_modal.you_wont_see_mentions": "Non vas ver as publicacións doutras persoas que a mencionen.",
  "boost_modal.combo": "Preme {combo} para ignorar isto na seguinte vez",
  "boost_modal.reblog": "Promover publicación?",
  "boost_modal.undo_reblog": "Retirar promoción?",
  "bundle_column_error.copy_stacktrace": "Copiar informe do erro",
  "bundle_column_error.error.body": "Non se puido mostrar a páxina solicitada. Podería deberse a un problema no código, ou incompatiblidade co navegador.",
  "bundle_column_error.error.title": "Vaites!",
  "bundle_column_error.network.body": "Algo fallou ao intentar cargar esta páxina. Podería ser un problema temporal da conexión a internet ao intentar comunicarte este servidor.",
  "bundle_column_error.network.title": "Fallo na rede",
  "bundle_column_error.retry": "Téntao de novo",
  "bundle_column_error.return": "Volver ao Inicio",
  "bundle_column_error.routing.body": "Non atopamos a páxina solicitada. Tes a certeza de que o URL na barra de enderezos é correcto?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Pechar",
  "bundle_modal_error.message": "Algo fallou mentras cargaba esta páxina.",
  "bundle_modal_error.retry": "Téntao de novo",
  "callout.dismiss": "Desbotar",
  "carousel.current": "<sr>Filmina</sr> {current, number} / {max, number}",
  "carousel.slide": "Filmina {current, number} de {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} caracteres recomendados",
  "character_counter.required": "{currentLength}/{maxLength} caracteres",
  "closed_registrations.other_server_instructions": "Cómo Mastodon é descentralizado, podes crear unha conta noutro servidor e interactuar igualmente con este.",
  "closed_registrations_modal.description": "Actualmente non é posible crear unha conta en {domain}, pero ten en conta que non precisas unha conta específicamente en {domain} para usar Mastodon.",
  "closed_registrations_modal.find_another_server": "Atopa outro servidor",
  "closed_registrations_modal.preamble": "Mastodon é descentralizado, así que non importa onde crees a conta, poderás seguir e interactuar con calquera conta deste servidor. Incluso podes ter o teu servidor!",
  "closed_registrations_modal.title": "Crear conta en Mastodon",
  "collection.share_modal.share_link_label": "Compartir ligazón",
  "collection.share_modal.share_via_post": "Publicar en Mastodon",
  "collection.share_modal.share_via_system": "Compartir con…",
  "collection.share_modal.title": "Compartir colección",
  "collection.share_modal.title_new": "Comparte a túa nova colección!",
  "collection.share_template_other": "Mira que colección máis boa: {link}",
  "collection.share_template_own": "Mira a miña nova colección: {link}",
  "collections.account_count": "{count, plural, one {# conta} other {# contas}}",
  "collections.accounts.empty_description": "Engade ate {count} contas",
  "collections.accounts.empty_editor_title": "Aínda non hai ninguén nesta colección",
  "collections.accounts.empty_title": "A colección está baleira",
  "collections.block_collection_owner": "Bloquear conta",
  "collections.by_account": "de {account_handle}",
  "collections.collection_description": "Descrición",
  "collections.collection_language": "Idioma",
  "collections.collection_language_none": "Ningún",
  "collections.collection_name": "Nome",
  "collections.collection_topic": "Temática",
  "collections.confirm_account_removal": "Tes certeza de querer retirar esta conta desta colección?",
  "collections.content_warning": "Aviso sobre o contido",
  "collections.continue": "Continuar",
  "collections.copy_link": "Copiar ligazón",
  "collections.copy_link_confirmation": "Copiouse ao portapapeis a ligazón á colección",
  "collections.create.accounts_title": "A quen queres incluír nesta colección?",
  "collections.create.basic_details_title": "Detalles básicos",
  "collections.create.steps": "Paso {step}/{total}",
  "collections.create_collection": "Crear colección",
  "collections.delete_collection": "Eliminar colección",
  "collections.description_length_hint": "Límite de 100 caracteres",
  "collections.detail.author_added_you_on_date": "{author} engadiute o {date}",
  "collections.detail.loading": "Cargando colección…",
  "collections.detail.revoke_inclusion": "Quítame de aí",
  "collections.detail.sensitive_content": "Contido sensible",
  "collections.detail.sensitive_note": "Esta colección presenta contas e contido que poderían ser sensibles para algunhas persoas.",
  "collections.detail.share": "Compartir esta colección",
  "collections.detail.you_are_in_this_collection": "Engadíronte a esta colección",
  "collections.edit_details": "Editar detalles",
  "collections.error_loading_collections": "Houbo un erro ao intentar cargar estas coleccións.",
  "collections.hidden_accounts_description": "Bloqueaches ou silenciaches {count, plural, one {esta conta} other {estas contas}}",
  "collections.hidden_accounts_link": "{count, plural, one {# conta oculta} other {# contas ocultas}}",
  "collections.hints.accounts_counter": "{count}/{max} contas",
  "collections.last_updated_at": "Última actualización: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# Colección} other {# Coleccións}}",
  "collections.list.created_by_author": "Creada por {name}",
  "collections.list.created_by_you": "Creada por ti",
  "collections.list.featuring_you": "Das que formas parte",
  "collections.manage_accounts": "Xestionar contas",
  "collections.mark_as_sensitive": "Marcar como sensible",
  "collections.mark_as_sensitive_hint": "Oculta a descrición e contas da colección detrás dun aviso sobre o contido. O nome da colección permanece visible.",
  "collections.maximum_collection_count_description": "O teu servidor permíteche crear ata {count} coleccións.",
  "collections.maximum_collection_count_reached": "Creaches o número máximo de coleccións",
  "collections.name_length_hint": "Límite de 40 caracteres",
  "collections.new_collection": "Nova colección",
  "collections.pending_accounts.message": "As contas poden aparecer como pendentes cando están agardando a resposta da usuaria no seu servidor. As contas pendentes só as podes ver ti.",
  "collections.pending_accounts.title": "Por que vexo contas que están pendentes?",
  "collections.remove_account": "Retirar",
  "collections.report_collection": "Denunciar esta colección",
  "collections.revoke_collection_inclusion": "Sácame desta colección",
  "collections.revoke_inclusion.confirmation": "Quitámoste da colección \"{collection}\"",
  "collections.revoke_inclusion.error": "Algo fallou, inténtao outra vez máis tarde.",
  "collections.search_accounts_label": "Busca contas para engadilas",
  "collections.search_accounts_max_reached": "Acadaches o máximo de contas permitidas",
  "collections.sensitive": "Sensible",
  "collections.share_short": "Compartir",
  "collections.suggestions.can_not_add": "Non se pode engadir",
  "collections.suggestions.can_not_add_desc": "Estas contas optaron por poder ser engadidas, ou pode que estean nun servidor que aínda non é compatible coas coleccións.",
  "collections.suggestions.must_follow": "Primeiro tes que seguila",
  "collections.suggestions.must_follow_desc": "Estas contas revisan todas as solicitudes de seguimento. As seguidoras poden engadilas a coleccións.",
  "collections.topic_hint": "Engadir un cancelo para que axudar a que outras persoas coñezan a temática desta colección.",
  "collections.topic_special_chars_hint": "Vanse eliminar os caracteres especiais ao gardar",
  "collections.unlisted_collections_description": "Estas non se mostran no teu perfil, pero calquera que coñeza a ligazón pode velas.",
  "collections.unlisted_collections_with_count": "Coleccións fóra do perfil ({count})",
  "collections.view_collection": "Ver colección",
  "collections.visibility_public": "Pública",
  "collections.visibility_public_hint": "Pódese atopar nos resultados das buscas e noutras áreas onde se mostran recomendacións.",
  "collections.visibility_title": "Visibilidade",
  "collections.visibility_unlisted": "Fóra das listas",
  "collections.visibility_unlisted_hint": "Visible para calquera que teña a ligazón. Oculta nos resultados e recomendacións.",
  "column.about": "Sobre",
  "column.blocks": "Usuarias bloqueadas",
  "column.bookmarks": "Marcadores",
  "column.community": "Cronoloxía local",
  "column.create_list": "Crear lista",
  "column.direct": "Mencións privadas",
  "column.directory": "Procurar perfís",
  "column.domain_blocks": "Dominios agochados",
  "column.edit_list": "Editar lista",
  "column.favourites": "Favoritas",
  "column.firehose": "O que acontece",
  "column.firehose_local": "Acontece agora neste servidor",
  "column.firehose_singular": "O que acontece",
  "column.follow_requests": "Peticións de seguimento",
  "column.home": "Inicio",
  "column.list_members": "Xestionar membros da lista",
  "column.lists": "Listaxes",
  "column.mutes": "Usuarias acaladas",
  "column.notifications": "Notificacións",
  "column.other_collections": "Coleccións de {name}",
  "column.pins": "Publicacións fixadas",
  "column.public": "Cronoloxía federada",
  "column.your_collections": "As túas coleccións",
  "column_back_button.label": "Volver",
  "column_header.hide_settings": "Agochar axustes",
  "column_header.moveLeft_settings": "Mover columna cara a esquerda",
  "column_header.moveRight_settings": "Mover columna cara a dereita",
  "column_header.pin": "Fixar",
  "column_header.show_settings": "Amosar axustes",
  "column_header.unpin": "Desapegar",
  "column_search.cancel": "Cancelar",
  "combobox.close_results": "Fechar os resultados",
  "combobox.loading": "Cargando",
  "combobox.no_results_found": "Non hai resultados para esta busca",
  "combobox.open_results": "Abrir resultados",
  "combobox.results_available": "{count, plural, one {# suxestións} other {# suxestións}} dispoñibles. Usa as frechas arriba e abaixo para desprazarte. Preme Enter para seleccionar.",
  "community.column_settings.local_only": "Só local",
  "community.column_settings.media_only": "Só multimedia",
  "community.column_settings.remote_only": "Só remoto",
  "compose.error.blank_post": "A publicación non pode estar baleira.",
  "compose.language.change": "Elixe o idioma",
  "compose.language.search": "Buscar idiomas...",
  "compose.published.body": "Mensaxe publicada.",
  "compose.published.open": "Abrir",
  "compose.saved.body": "Publicación gardada.",
  "compose_form.direct_message_warning_learn_more": "Saber máis",
  "compose_form.encryption_warning": "As publicacións en Mastodon non están cifradas de extremo-a-extremo. Non compartas información sensible en Mastodon.",
  "compose_form.hashtag_warning": "Esta publicación non aparecerá incluída na lista dos cancelos xa que non é pública. Só se poden buscar cancelos nas publicacións públicas.",
  "compose_form.lock_disclaimer": "A túa conta non está {locked}. Todas poden seguirte para ollar os teus toots só para seguidoras.",
  "compose_form.lock_disclaimer.lock": "bloqueada",
  "compose_form.placeholder": "Que contas?",
  "compose_form.poll.duration": "Duración da enquisa",
  "compose_form.poll.multiple": "Escolla múltiple",
  "compose_form.poll.option_placeholder": "Opción {number}",
  "compose_form.poll.single": "Opción única",
  "compose_form.poll.switch_to_multiple": "Mudar a enquisa para permitir múltiples escollas",
  "compose_form.poll.switch_to_single": "Mudar a enquisa para permitir unha soa opción",
  "compose_form.poll.type": "Estilo",
  "compose_form.publish": "Publicar",
  "compose_form.reply": "Responder",
  "compose_form.save_changes": "Actualizar",
  "compose_form.spoiler.marked": "Retirar o aviso sobre o contido",
  "compose_form.spoiler.unmarked": "Engadir aviso sobre o contido",
  "compose_form.spoiler_placeholder": "Aviso sobre o contido (optativo)",
  "confirmation_modal.cancel": "Cancelar",
  "confirmations.block.confirm": "Bloquear",
  "confirmations.delete.confirm": "Eliminar",
  "confirmations.delete.message": "Tes a certeza de querer eliminar esta publicación?",
  "confirmations.delete.title": "Eliminar a publicación?",
  "confirmations.delete_collection.confirm": "Eliminar",
  "confirmations.delete_collection.message": "Esta acción non se pode desfacer.",
  "confirmations.delete_collection.title": "Eliminar \"{name}\"?",
  "confirmations.delete_list.confirm": "Eliminar",
  "confirmations.delete_list.message": "Tes a certeza de querer eliminar de xeito permanente esta listaxe?",
  "confirmations.delete_list.title": "Eliminar a lista?",
  "confirmations.discard_draft.confirm": "Desbotar e continuar",
  "confirmations.discard_draft.edit.cancel": "Seguir editando",
  "confirmations.discard_draft.edit.message": "Se continúas desbotarás os cambios realizados na publicación que estás a editar.",
  "confirmations.discard_draft.edit.title": "Desbotar os cambios na publicación?",
  "confirmations.discard_draft.post.cancel": "Retomar o borrador",
  "confirmations.discard_draft.post.message": "Se continúas desbotarás a publicación que estás a escribir.",
  "confirmations.discard_draft.post.title": "Desbotar o borrador?",
  "confirmations.discard_edit_media.confirm": "Descartar",
  "confirmations.discard_edit_media.message": "Tes cambios sen gardar para a vista previa ou descrición do multimedia, descartamos os cambios?",
  "confirmations.follow_to_list.confirm": "Seguir e engadir á lista",
  "confirmations.follow_to_list.message": "Tes que seguir a {name} para poder engadila a unha lista.",
  "confirmations.follow_to_list.title": "Seguir á usuaria?",
  "confirmations.hide_featured_tab.confirm": "Ocultar pestana",
  "confirmations.hide_featured_tab.intro": "Podes cambiar isto cando queiras nos axustes en <i>Editar perfil > pestana Perfil</i>.",
  "confirmations.hide_featured_tab.message": "Vas ocultar a pestana para as usuarias de {serverName} e outros servidores que usen a última versión de Mastodon. Noutros lugares podería ser diferente.",
  "confirmations.hide_featured_tab.title": "Ocultar a pestana «Destacado»?",
  "confirmations.logout.confirm": "Pechar sesión",
  "confirmations.logout.message": "Desexas pechar a sesión?",
  "confirmations.logout.title": "Pechar sesión?",
  "confirmations.missing_alt_text.confirm": "Engadir texto descritivo",
  "confirmations.missing_alt_text.message": "A publicación contén multimedia sen un texto que o describa. Ao engadir a descrición fas o contido accesible para máis persoas.",
  "confirmations.missing_alt_text.secondary": "Publicar igualmente",
  "confirmations.missing_alt_text.title": "Engadir texto descritivo?",
  "confirmations.mute.confirm": "Acalar",
  "confirmations.private_quote_notify.cancel": "Volver á edición",
  "confirmations.private_quote_notify.confirm": "Publicar publicación",
  "confirmations.private_quote_notify.do_not_show_again": "Non me volvas a mostrar esta mensaxe",
  "confirmations.private_quote_notify.message": "A persoa que estás a citar e outras contas mencionadas serán notificadas e poderán ver a túa publicación, incluso se non te seguen.",
  "confirmations.private_quote_notify.title": "Compartir coas seguidoras e coas usuarias mencionadas?",
  "confirmations.quiet_post_quote_info.dismiss": "Non lembrarmo máis",
  "confirmations.quiet_post_quote_info.got_it": "Entendido",
  "confirmations.quiet_post_quote_info.message": "Ao citar unha publicación pública limitada a túa publicación non aparecerá nas cronoloxías de tendencias.",
  "confirmations.quiet_post_quote_info.title": "Citar publicacións públicas limitadas",
  "confirmations.redraft.confirm": "Eliminar e reescribir",
  "confirmations.redraft.message": "Tes a certeza de querer eliminar esta publicación e reescribila? Perderás as promocións e favorecementos, e as respostas á publicación orixinal ficarán orfas.",
  "confirmations.redraft.title": "Eliminar e reescribir a publicación?",
  "confirmations.remove_from_followers.confirm": "Quitar seguidora",
  "confirmations.remove_from_followers.message": "{name} vai deixar de seguirte. É isto o que queres?",
  "confirmations.remove_from_followers.title": "Quitar seguidora?",
  "confirmations.revoke_collection_inclusion.confirm": "Quítame",
  "confirmations.revoke_collection_inclusion.message": "A acción é definitiva, a creadora da colección non poderá volver a engadirte máis adiante.",
  "confirmations.revoke_collection_inclusion.title": "Queres que non te inclúan nesta colección?",
  "confirmations.revoke_quote.confirm": "Eliminar publicación",
  "confirmations.revoke_quote.message": "Esta acción non se pode desfacer.",
  "confirmations.revoke_quote.title": "Eliminar publicación?",
  "confirmations.unblock.confirm": "Desbloquear",
  "confirmations.unblock.title": "Desbloquear a {name}?",
  "confirmations.unfollow.confirm": "Deixar de seguir",
  "confirmations.unfollow.title": "Deixa de seguir a {name}?",
  "confirmations.withdraw_request.confirm": "Retirar solicitude",
  "confirmations.withdraw_request.title": "Retirar a petición de seguimento para {name}?",
  "content_warning.hide": "Agochar publicación",
  "content_warning.show": "Mostrar igualmente",
  "content_warning.show_more": "Mostrar máis",
  "content_warning.show_short": "Mostrar",
  "conversation.delete": "Eliminar conversa",
  "conversation.mark_as_read": "Marcar como lido",
  "conversation.open": "Ver conversa",
  "conversation.with": "Con {names}",
  "copy_icon_button.copied": "Copiada ao portapapeis",
  "copy_icon_button.copy_this_text": "Copiar a ligazón ao portapapeis",
  "copypaste.copied": "Copiado",
  "copypaste.copy_to_clipboard": "Copiar ao portapapeis",
  "directory.federated": "Do fediverso coñecido",
  "directory.local": "Só de {domain}",
  "directory.new_arrivals": "Recén chegadas",
  "directory.recently_active": "Activas recentemente",
  "disabled_account_banner.account_settings": "Axustes da conta",
  "disabled_account_banner.text": "Actualmente a túa conta {disabledAccount} está desactivada.",
  "dismissable_banner.community_timeline": "Estas son as publicacións máis recentes das persoas que teñen a súa conta en {domain}.",
  "dismissable_banner.dismiss": "Desbotar",
  "dismissable_banner.public_timeline": "Estas son as publicacións públicas más recentes das persoas do fediverso seguidas por persoas de {domain}.",
  "domain_block_modal.block": "Bloquear servidor",
  "domain_block_modal.block_account_instead": "Prefiro bloquear a @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "As persoas deste servidor poden interactuar coas túas publicacións antigas.",
  "domain_block_modal.they_cant_follow": "Ninguén deste servidor pode seguirte.",
  "domain_block_modal.they_wont_know": "Non saberá que a bloqueaches.",
  "domain_block_modal.title": "Bloquear dominio?",
  "domain_block_modal.you_will_lose_num_followers": "Vas perder {followersCount, plural, one {{followersCountDisplay} seguidora} other {{followersCountDisplay} seguidoras}} e {followingCount, plural, one {{followingCountDisplay} persoa que segues} other {{followingCountDisplay} persoas que segues}}.",
  "domain_block_modal.you_will_lose_relationships": "Vas perder todas as seguidoras e seguimentos a persoas deste servidor.",
  "domain_block_modal.you_wont_see_posts": "Non verás publicacións ou notificacións das usuarias deste servidor.",
  "domain_pill.activitypub_lets_connect": "Permíteche conectar e interactuar con persoas non só de Mastodon, se non tamén con outras  sociais.",
  "domain_pill.activitypub_like_language": "ActivityPub é algo así como o idioma que Mastodon fala con outras redes sociais.",
  "domain_pill.server": "Servidor",
  "domain_pill.their_handle": "O seu alcume:",
  "domain_pill.their_server": "O seu fogar dixital, onde están as súas publicacións.",
  "domain_pill.their_username": "O seu identificador único no seu servidor. É posible atopar usuarias co mesmo nome de usuaria en diferentes servidores.",
  "domain_pill.username": "Nome de usuaria",
  "domain_pill.whats_in_a_handle": "As partes do alcume?",
  "domain_pill.who_they_are": "O alcume dinos quen é esa persoa e onde está, para que poidas interactuar con ela en toda a web social das <button>plataformas ActivityPub</button>.",
  "domain_pill.who_you_are": "Como o teu alcume informa de quen es e onde estás, as persoas poden interactuar contigo desde toda a web social das <button>plataformas ActivityPub</button>.",
  "domain_pill.your_handle": "O teu alcume:",
  "domain_pill.your_server": "O teu fogar dixital, onde están as túas publicacións. Non é do teu agrado? Podes cambiar de servidor cando queiras levando as túas seguidoras contigo.",
  "domain_pill.your_username": "O teu identificador único neste servidor. É posible que atopes usuarias co mesmo nome de usuaria en outros servidores.",
  "dropdown.empty": "Escolle unha opción",
  "email_subscriptions.email": "Correo electrónico",
  "email_subscriptions.form.action": "Subscribirse",
  "email_subscriptions.form.bottom": "Recibe publicacións no teu correo sen precisar crear unha conta de Mastodon. Date de baixa cando queiras. Máis información na <a>Directiva de privacidade</a>.",
  "email_subscriptions.form.title": "Subscríbete para recibir actualizacións por correo de {name}",
  "email_subscriptions.submitted.lead": "Comproba a túa caixa de correo para completar a subscrición ás actualizacións por correo.",
  "email_subscriptions.submitted.title": "Un último paso",
  "email_subscriptions.validation.email.blocked": "Provedor de correo bloqueado",
  "email_subscriptions.validation.email.invalid": "Enderezo de correo non válido",
  "embed.instructions": "Inclúe esta publicación no teu sitio web copiando o seguinte código.",
  "embed.preview": "Vaise ver así:",
  "emoji_button.activity": "Actividade",
  "emoji_button.clear": "Limpar",
  "emoji_button.custom": "Personalizado",
  "emoji_button.flags": "Marcas",
  "emoji_button.food": "Comida e Bebida",
  "emoji_button.label": "Inserir emoticona",
  "emoji_button.nature": "Natureza",
  "emoji_button.not_found": "Non se atoparon emojis",
  "emoji_button.objects": "Obxectos",
  "emoji_button.people": "Persoas",
  "emoji_button.recent": "Empregadas acotío",
  "emoji_button.search": "Procurar...",
  "emoji_button.search_results": "Resultados da procura",
  "emoji_button.symbols": "Símbolos",
  "emoji_button.travel": "Viaxes e Lugares",
  "empty_column.account_featured.other": "{acct} aínda non destacou nada.",
  "empty_column.account_featured_self.no_collections_button": "Crea unha colección",
  "empty_column.account_featured_self.no_collections_hide_tab": "Ocultar esta pestana entonces",
  "empty_column.account_featured_self.pre_collections": "Van chegar as Coleccións",
  "empty_column.account_featured_self.pre_collections_desc": "Coas Coleccións (a partir de Mastodon 4.6) podes crear as túas listas persoais de contas para recomendar a outras persoas.",
  "empty_column.account_featured_self.showcase_accounts": "Salienta as túas contas favoritas",
  "empty_column.account_featured_self.showcase_accounts_desc": "As coleccións son listas de contas para que outras persoas as coñezan e desfruten aquí no Fediverso.",
  "empty_column.account_featured_unknown.other": "Esta conta aínda non destacou nada.",
  "empty_column.account_hides_collections": "A usuaria decideu non facer pública esta información",
  "empty_column.account_suspended": "Conta suspendida",
  "empty_column.account_timeline": "Non hai publicacións aquí!",
  "empty_column.account_unavailable": "Perfil non dispoñible",
  "empty_column.blocks": "Aínda non bloqueaches a ningún usuaria.",
  "empty_column.bookmarked_statuses": "Aínda non marcaches ningunha publicación. Cando o fagas, aparecerán aquí.",
  "empty_column.collections.featured_in": "Non te engadiron a ningunha colección.",
  "empty_column.community": "A cronoloxía local está baleira. Escribe algo de xeito público para espallalo!",
  "empty_column.direct": "Aínda non tes mencións privadas. Cando envíes ou recibas unha, aparecerá aquí.",
  "empty_column.disabled_feed": "A administración do teu servidor desactivou esta canle.",
  "empty_column.domain_blocks": "Aínda non hai dominios agochados.",
  "empty_column.explore_statuses": "Non hai temas en voga. Volve máis tarde!",
  "empty_column.favourited_statuses": "Aínda non tes publicacións favoritas. Cando favorezas unha, aparecerá aquí.",
  "empty_column.favourites": "Ninguén marcou como favorita esta publicación. Cando alguén o faga, aparecerá aquí.",
  "empty_column.follow_requests": "Non tes peticións de seguimento. Cando recibas unha, amosarase aquí.",
  "empty_column.followed_tags": "Aínda non seguiches ningún cancelo. Cando o fagas aparecerán aquí.",
  "empty_column.hashtag": "Aínda non hai nada con este cancelo.",
  "empty_column.home": "A túa cronoloxía inicial está baleira! Sigue a outras usuarias para enchela.",
  "empty_column.list": "Aínda non hai nada nesta listaxe. Cando as usuarias incluídas na listaxe publiquen mensaxes, amosaranse aquí.",
  "empty_column.mutes": "Aínda non silenciaches a ningúnha usuaria.",
  "empty_column.notification_requests": "Todo ben! Nada por aquí. Cando recibas novas notificacións aparecerán aquí seguindo o criterio dos teus axustes.",
  "empty_column.notifications": "Aínda non tes notificacións. Aparecerán cando outras persoas interactúen contigo.",
  "empty_column.public": "Nada por aquí! Escribe algo de xeito público, ou segue de xeito manual usuarias doutros servidores para ir enchéndoo",
  "empty_state.no_results": "Sen resultados",
  "error.no_hashtag_feed_access": "Crea unha conta ou accede para ver e seguir este cancelo.",
  "error.unexpected_crash.explanation": "Debido a un erro no noso código ou a unha compatilidade co teu navegador, esta páxina non pode ser amosada correctamente.",
  "error.unexpected_crash.explanation_addons": "Non se puido mostrar correctamente a páxina. Habitualmente este erro está causado por algún engadido do navegador ou ferramentas de tradución automática.",
  "error.unexpected_crash.next_steps": "Tenta actualizar a páxina. Se isto non axuda podes tamén empregar Mastodon noutro navegador ou aplicación nativa.",
  "error.unexpected_crash.next_steps_addons": "Intenta desactivalas e actualiza a páxina. Se isto non funciona, podes seguir usando Mastodon nun navegador diferente ou aplicación nativa.",
  "errors.unexpected_crash.copy_stacktrace": "Copiar trazas (stacktrace) ó portapapeis",
  "errors.unexpected_crash.report_issue": "Informar sobre un problema",
  "explore.suggested_follows": "Persoas",
  "explore.title": "Popular",
  "explore.trending_links": "Novas",
  "explore.trending_statuses": "Publicacións",
  "explore.trending_tags": "Cancelos",
  "featured_carousel.current": "<sr>Publicación</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Publicación fixada} other {Publicacións fixadas}}",
  "featured_carousel.slide": "Publicación {current, number} de {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Ultimamente publicaches sobre {items}. Engadimos isto como cancelos destacados?",
  "featured_tags.suggestions.add": "Engadir",
  "featured_tags.suggestions.added": "Xestiona os teus cancelos destacados cando queiras en <link>Editar perfil > Cancelos destacados</link>.",
  "featured_tags.suggestions.dismiss": "Non, grazas",
  "filter_modal.added.context_mismatch_explanation": "Esta categoría de filtro non se aplica ao contexto no que accedeches a esta publicación. Se queres que a publicación se filtre nese contexto tamén, terás que editar o filtro.",
  "filter_modal.added.context_mismatch_title": "Non concorda o contexto!",
  "filter_modal.added.expired_explanation": "Esta categoría de filtro caducou, terás que cambiar a data de caducidade para que se aplique.",
  "filter_modal.added.expired_title": "Filtro caducado!",
  "filter_modal.added.review_and_configure": "Para revisar e despois configurar esta categoría de filtro, vaite a {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Axustes do filtro",
  "filter_modal.added.settings_link": "páxina de axustes",
  "filter_modal.added.short_explanation": "Engadiuse esta publicación á seguinte categoría de filtro: {title}.",
  "filter_modal.added.title": "Filtro engadido!",
  "filter_modal.select_filter.context_mismatch": "non se aplica neste contexto",
  "filter_modal.select_filter.expired": "caducado",
  "filter_modal.select_filter.prompt_new": "Nova categoría: {name}",
  "filter_modal.select_filter.search": "Buscar ou crear",
  "filter_modal.select_filter.subtitle": "Usar unha categoría existente ou crear unha nova",
  "filter_modal.select_filter.title": "Filtrar esta publicación",
  "filter_modal.title.status": "Filtrar unha publicación",
  "filter_warning.matches_filter": "Concorda co filtro «<span>{title}</span>»",
  "filtered_notifications_banner.pending_requests": "De {count, plural, =0 {ninguén} one {unha persoa} other {# persoas}} que igual coñeces",
  "filtered_notifications_banner.title": "Notificacións filtradas",
  "firehose.all": "Todo",
  "firehose.local": "Este servidor",
  "firehose.remote": "Outros servidores",
  "follow_request.authorize": "Autorizar",
  "follow_request.reject": "Rexeitar",
  "follow_requests.unlocked_explanation": "Malia que a túa conta non é privada, a administración de {domain} pensou que quizabes terías que revisar de xeito manual as solicitudes de seguiminto.",
  "follow_suggestions.curated_suggestion": "Suxestións do Servidor",
  "follow_suggestions.dismiss": "Non mostrar máis",
  "follow_suggestions.featured_longer": "Elección persoal do equipo de {domain}",
  "follow_suggestions.friends_of_friends_longer": "Popular entre as persoas que segues",
  "follow_suggestions.hints.featured": "Este perfil foi escollido pola administración de {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Este perfil é popular entre as persoas que segues.",
  "follow_suggestions.hints.most_followed": "Este perfil é un dos máis seguidos en {domain}.",
  "follow_suggestions.hints.most_interactions": "Este perfil tivo moitas interaccións últimamente en {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Este perfil ten semellanzas cos perfís que ti seguiches últimamente.",
  "follow_suggestions.personalized_suggestion": "Suxestión personalizada",
  "follow_suggestions.popular_suggestion": "Suxestión popular",
  "follow_suggestions.popular_suggestion_longer": "Popular en {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Perfís semellantes aos que seguiches recentemente",
  "follow_suggestions.view_all": "Ver todas",
  "follow_suggestions.who_to_follow": "A quen seguir",
  "followed_tags": "Cancelos seguidos",
  "followers.hide_other_followers": "Esta usuaria escolleu non mostrar as outras persoas que a seguen",
  "followers.title": "Seguindo a {name}",
  "following.hide_other_following": "Esta usuaria escolleu non mostrar as outras persoas que segue",
  "following.title": "Seguida por {name}",
  "footer.about": "Sobre",
  "footer.about_mastodon": "Sobre Mastodon",
  "footer.about_server": "Sobre {domain}",
  "footer.about_this_server": "Sobre",
  "footer.directory": "Directorio de perfís",
  "footer.get_app": "Descarga a app",
  "footer.keyboard_shortcuts": "Atallos do teclado",
  "footer.privacy_policy": "Política de privacidade",
  "footer.source_code": "Ver código fonte",
  "footer.status": "Estado",
  "footer.terms_of_service": "Condicións do servizo",
  "form_error.blank": "O campo non pode quedar baleiro.",
  "form_field.optional": "(optativo)",
  "generic.saved": "Gardado",
  "getting_started.heading": "Primeiros pasos",
  "hashtag.admin_moderation": "Abrir interface de moderación para ##{name}",
  "hashtag.browse": "Ver publicacións con #{hashtag}",
  "hashtag.browse_from_account": "Ver as publicacións de @{name} con #{hashtag}",
  "hashtag.column_header.tag_mode.all": "e {additional}",
  "hashtag.column_header.tag_mode.any": "ou {additional}",
  "hashtag.column_header.tag_mode.none": "sen {additional}",
  "hashtag.column_settings.select.no_options_message": "Non se atoparon suxestións",
  "hashtag.column_settings.select.placeholder": "Inserir cancelos…",
  "hashtag.column_settings.tag_mode.all": "Todos estes",
  "hashtag.column_settings.tag_mode.any": "Calquera destes",
  "hashtag.column_settings.tag_mode.none": "Ningún destes",
  "hashtag.column_settings.tag_toggle": "Incluír cancelos adicionais para esta columna",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} participante} other {{counter} participantes}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} publicación} other {{counter} publicacións}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} publicación} other {{counter} publicacións}} hoxe",
  "hashtag.feature": "Destacar no perfil",
  "hashtag.follow": "Seguir cancelo",
  "hashtag.mute": "Acalar a #{hashtag}",
  "hashtag.unfeature": "Non destacar no perfil",
  "hashtag.unfollow": "Deixar de seguir cancelo",
  "hashtags.and_other": "…e {count, plural, one {}other {# máis}}",
  "hints.profiles.followers_may_be_missing": "Poderían faltar seguidoras deste perfil.",
  "hints.profiles.follows_may_be_missing": "Poderían faltar seguimentos deste perfil.",
  "hints.profiles.posts_may_be_missing": "Poderían faltar algunhas publicacións deste perfil.",
  "hints.profiles.see_more_followers": "Mira máis seguidoras en {domain}",
  "hints.profiles.see_more_follows": "Mira máis seguimentos en {domain}",
  "hints.profiles.see_more_posts": "Mira máis publicacións en {domain}",
  "home.column_settings.show_quotes": "Mostrar citas",
  "home.column_settings.show_reblogs": "Amosar compartidos",
  "home.column_settings.show_replies": "Amosar respostas",
  "home.hide_announcements": "Agochar anuncios",
  "home.pending_critical_update.body": "Por favor actualiza o antes posible o teu servidor Mastodon!",
  "home.pending_critical_update.link": "Mira as actualizacións",
  "home.pending_critical_update.title": "Hai una actualización crítica de seguridade!",
  "home.show_announcements": "Amosar anuncios",
  "ignore_notifications_modal.disclaimer": "Mastodon non pode informar ás usuarias de que ignoraches as súas notificacións. Ao ignorar as notificacións non evitarás que as mensaxes sexan enviadas igualmente.",
  "ignore_notifications_modal.filter_instead": "Filtrar igualmente",
  "ignore_notifications_modal.filter_to_act_users": "Poderás seguir aceptando, rexeitando e denunciando usuarias",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Ao filtrar axudas a evitar posibles confusións",
  "ignore_notifications_modal.filter_to_review_separately": "Podes revisar por separado as notificacións filtradas",
  "ignore_notifications_modal.ignore": "Ignorar notificacións",
  "ignore_notifications_modal.limited_accounts_title": "Ignorar notificacións desde contas limitadas?",
  "ignore_notifications_modal.new_accounts_title": "Ignorar notificacións desde novas contas?",
  "ignore_notifications_modal.not_followers_title": "Ignorar notificacións de persoas que non te seguen?",
  "ignore_notifications_modal.not_following_title": "Ignorar notificacións de persoas que non segues?",
  "ignore_notifications_modal.private_mentions_title": "Ignorar notificacións de Mencións Privadas non solicitadas?",
  "info_button.label": "Axuda",
  "info_button.what_is_alt_text": "<h1>Que é o Texto Alternativo?</h1> <p>O Text Alt proporciona a descrición das imaxes para as persoas con deficiencias visuais, conexións a internet de baixa calidade ou para engadir contexto ás mesmas.</p> <p>Podes mellorar a accesibilidade e a comprensión da publicación ao escribir un texto alternativo claro, conciso e obxectivo.</p> <ul> <li>Identifica os elementos importantes</li> <li>Inclúe o texto que apareza nas imaxes</li> <li>Utiliza sintaxe estándar nas frases</li> <li>Evita información redundante</li> <li>Céntrate nos elementos principais cando sexan imaxes complexas (como diagramas ou mapas)</li> </ul>",
  "interaction_modal.action": "Para interactuar coa publicación de {name} debes iniciar sesión no servidor Mastodon que utilices.",
  "interaction_modal.action_follow": "Para seguir a {name} tes que iniciar sesión no servidor de Mastodon que utilices.",
  "interaction_modal.go": "Ir",
  "interaction_modal.no_account_yet": "Aínda non tes unha conta?",
  "interaction_modal.on_another_server": "Nun servidor diferente",
  "interaction_modal.on_this_server": "Neste servidor",
  "interaction_modal.title": "Inicia sesión para continuar",
  "interaction_modal.username_prompt": "Ex. {example}",
  "intervals.full.days": "{number, plural,one {# día} other {# días}}",
  "intervals.full.hours": "{number, plural, one {# hora} other {# horas}}",
  "intervals.full.minutes": "{number, plural, one {# minuto} other {# minutos}}",
  "keyboard_shortcuts.back": "Volver atrás",
  "keyboard_shortcuts.blocked": "Abrir lista de usuarias bloqueadas",
  "keyboard_shortcuts.boost": "Promover publicación",
  "keyboard_shortcuts.column": "Destacar unha columna",
  "keyboard_shortcuts.compose": "Por o cursor na área de escritura",
  "keyboard_shortcuts.description": "Descrición",
  "keyboard_shortcuts.direct": "Abrir a columna de mencións privadas",
  "keyboard_shortcuts.down": "Para mover cara abaixo na listaxe",
  "keyboard_shortcuts.enter": "Para abrir publicación",
  "keyboard_shortcuts.explore": "Abrir cronoloxía coas tendencias",
  "keyboard_shortcuts.favourite": "Marcar como favorita",
  "keyboard_shortcuts.favourites": "Para abrir a lista das favoritas",
  "keyboard_shortcuts.federated": "Para abrir a cronoloxía federada",
  "keyboard_shortcuts.heading": "Atallos do teclado",
  "keyboard_shortcuts.home": "Para abrir a cronoloxía inicial",
  "keyboard_shortcuts.hotkey": "Tecla de atallo",
  "keyboard_shortcuts.legend": "Para amosar esta lenda",
  "keyboard_shortcuts.load_more": "Foco no botón \"Cargar máis\"",
  "keyboard_shortcuts.local": "Para abrir a cronoloxía local",
  "keyboard_shortcuts.mention": "Para mencionar a autora",
  "keyboard_shortcuts.muted": "Abrir lista de usuarias acaladas",
  "keyboard_shortcuts.my_profile": "Para abrir o teu perfil",
  "keyboard_shortcuts.notifications": "Para abrir a columna das notificacións",
  "keyboard_shortcuts.open_media": "Para abrir o contido multimedia",
  "keyboard_shortcuts.pinned": "Para abrir a listaxe das publicacións fixadas",
  "keyboard_shortcuts.profile": "Para abrir o perfil da autora",
  "keyboard_shortcuts.quote": "Citar publicación",
  "keyboard_shortcuts.reply": "Para responder",
  "keyboard_shortcuts.requests": "Para abrir a listaxe das peticións de seguimento",
  "keyboard_shortcuts.search": "Por cursor na caixa de busca",
  "keyboard_shortcuts.spoilers": "Mostrar/ocultar campo CW",
  "keyboard_shortcuts.start": "Para abrir a columna dos \"primeiros pasos\"",
  "keyboard_shortcuts.toggle_hidden": "Para mostrar o texto tras Aviso de Contido (CW)",
  "keyboard_shortcuts.toggle_sensitivity": "Para amosar/agochar contido multimedia",
  "keyboard_shortcuts.toot": "Para escribir unha nova publicación",
  "keyboard_shortcuts.top": "Mover arriba de todo",
  "keyboard_shortcuts.translate": "para traducir unha publicación",
  "keyboard_shortcuts.unfocus": "Para deixar de destacar a área de escritura/procura",
  "keyboard_shortcuts.up": "Para mover cara arriba na listaxe",
  "learn_more_link.got_it": "Entendo",
  "learn_more_link.learn_more": "Saber máis",
  "lightbox.close": "Fechar",
  "lightbox.next": "Seguinte",
  "lightbox.previous": "Anterior",
  "lightbox.zoom_in": "Ver tamaño real",
  "lightbox.zoom_out": "Ver tamaño axustado",
  "limited_account_hint.action": "Mostrar perfil igualmente",
  "limited_account_hint.title": "Este perfil foi agochado pola moderación de {domain}.",
  "link_preview.author": "Por {name}",
  "link_preview.more_from_author": "Máis de {name}",
  "link_preview.shares": "{count, plural, one {{counter} publicación} other {{counter} publicacións}}",
  "lists.add_member": "Engadir",
  "lists.add_to_list": "Engadir á lista",
  "lists.add_to_lists": "Engadir {name} ás listas",
  "lists.create": "Crear",
  "lists.create_a_list_to_organize": "Crear unha nova lista para organizar o teu Inicio",
  "lists.create_list": "Crear lista",
  "lists.delete": "Eliminar listaxe",
  "lists.done": "Feito",
  "lists.edit": "Editar listaxe",
  "lists.exclusive": "Ocultar membros no Inicio",
  "lists.exclusive_hint": "Se alguén está nesta lista non aparerá na cronoloxía de Inicio para evitar duplicidades das publicacións.",
  "lists.find_users_to_add": "Buscar persoas que engadir",
  "lists.list_members_count": "{count, plural, one {# membro} other {# membros}}",
  "lists.list_name": "Nome da lista",
  "lists.new_list_name": "Novo nome da lista",
  "lists.no_lists_yet": "Aínda non hai listas.",
  "lists.no_members_yet": "Aínda non hai membros.",
  "lists.no_results_found": "Non se atoparon resultados.",
  "lists.remove_member": "Retirar",
  "lists.replies_policy.followed": "Calquera usuaria que siga",
  "lists.replies_policy.list": "Membros da lista",
  "lists.replies_policy.none": "Ninguén",
  "lists.save": "Gardar",
  "lists.search": "Buscar",
  "lists.show_replies_to": "Incluír respostas dos membros das listas a",
  "load_pending": "{count, plural, one {# novo elemento} other {# novos elementos}}",
  "loading_indicator.label": "Estase a cargar…",
  "media_gallery.hide": "Agochar",
  "moved_to_account_banner.text": "A túa conta {disabledAccount} está actualmente desactivada porque movéchela a {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Agochar nas notificacións",
  "mute_modal.hide_options": "Opcións ao ocultar",
  "mute_modal.indefinite": "Ata que as reactive",
  "mute_modal.show_options": "Mostrar opcións",
  "mute_modal.they_can_mention_and_follow": "Pódete mencionar e seguirte, pero non a verás.",
  "mute_modal.they_wont_know": "Non saberá que a acalaches.",
  "mute_modal.title": "Acalar usuaria?",
  "mute_modal.you_wont_see_mentions": "Non verás as publicacións que a mencionen.",
  "mute_modal.you_wont_see_posts": "Seguirá podendo ler as túas publicacións, pero non verás as súas.",
  "navigation_bar.about": "Sobre",
  "navigation_bar.account_settings": "Contrasinal e seguridade",
  "navigation_bar.administration": "Administración",
  "navigation_bar.advanced_interface": "Abrir coa interface web avanzada",
  "navigation_bar.automated_deletion": "Borrado automático das publicacións",
  "navigation_bar.blocks": "Usuarias bloqueadas",
  "navigation_bar.bookmarks": "Marcadores",
  "navigation_bar.collections": "Coleccións",
  "navigation_bar.direct": "Mencións privadas",
  "navigation_bar.domain_blocks": "Dominios agochados",
  "navigation_bar.favourites": "Favoritas",
  "navigation_bar.filters": "Palabras silenciadas",
  "navigation_bar.follow_requests": "Peticións de seguimento",
  "navigation_bar.followed_tags": "Cancelos seguidos",
  "navigation_bar.follows_and_followers": "Seguindo e seguidoras",
  "navigation_bar.import_export": "Importar e exportar",
  "navigation_bar.lists": "Listaxes",
  "navigation_bar.live_feed_local": "En directo (local)",
  "navigation_bar.live_feed_public": "En directo (federada)",
  "navigation_bar.logout": "Pechar sesión",
  "navigation_bar.moderation": "Moderación",
  "navigation_bar.more": "Máis",
  "navigation_bar.mutes": "Usuarias silenciadas",
  "navigation_bar.opened_in_classic_interface": "Publicacións, contas e outras páxinas dedicadas ábrense por defecto na interface web clásica.",
  "navigation_bar.preferences": "Preferencias",
  "navigation_bar.privacy_and_reach": "Privacidade e alcance",
  "navigation_bar.search": "Buscar",
  "navigation_bar.search_trends": "Buscar / Popular",
  "navigation_panel.collapse_followed_tags": "Pregar o menú de cancelos seguidos",
  "navigation_panel.collapse_lists": "Pregar menú da lista",
  "navigation_panel.expand_followed_tags": "Despregar menú de cancelos seguidos",
  "navigation_panel.expand_lists": "Despregar menú da lista",
  "not_signed_in_indicator.not_signed_in": "Debes acceder para ver este recurso.",
  "notification.added_to_collection": "{name} engadíute a unha colección",
  "notification.admin.report": "{name} denunciou a {target}",
  "notification.admin.report_account": "{name} denunciou {count, plural, one {unha publicación} other {# publicacións}} de {target} por {category}",
  "notification.admin.report_account_other": "{name} denunciou {count, plural, one {unha publicación} other {# publicacións}} de {target}",
  "notification.admin.report_statuses": "{name} deununciou a {target} por {category}",
  "notification.admin.report_statuses_other": "{name} denunciou a {target}",
  "notification.admin.sign_up": "{name} rexistrouse",
  "notification.admin.sign_up.name_and_others": "{name} e {count, plural, one {# máis} other {# máis}} crearon unha conta",
  "notification.annual_report.message": "#Wrapstodon de {year} agarda por ti! Desvela os momentos máis destacados e historias reseñables en Mastodon!",
  "notification.annual_report.view": "Ver #Wrapstodon",
  "notification.collection_update": "{name} editou unha colección na que apareces",
  "notification.favourite": "{name} marcou como favorita a túa publicación",
  "notification.favourite.name_and_others_with_link": "{name} e <a>{count, plural, one {# máis} other {# máis}}</a> favoreceron a túa publicación",
  "notification.favourite_pm": "{name} favoreceu a túa mención privada",
  "notification.favourite_pm.name_and_others_with_link": "{name} e <a>{count, plural, one {outra persoa} other {outras # persoas}}</a> favoreceron a túa mención privada",
  "notification.follow": "{name} comezou a seguirte",
  "notification.follow.name_and_others": "{name} e <a>{count, plural, one {# mais} other {# mais}}</a> seguíronte",
  "notification.follow_request": "{name} solicitou seguirte",
  "notification.follow_request.name_and_others": "{name} e {count, plural, one {# máis} other {# máis}} solicitaron seguirte",
  "notification.label.mention": "Mención",
  "notification.label.private_mention": "Mención privada",
  "notification.label.private_reply": "Resposta privada",
  "notification.label.quote": "{name} citou a túa publicación",
  "notification.label.reply": "Resposta",
  "notification.mention": "Mención",
  "notification.mentioned_you": "{name} mencionoute",
  "notification.moderation-warning.learn_more": "Saber máis",
  "notification.moderation_warning": "Recibiches unha advertencia da moderación",
  "notification.moderation_warning.action_delete_statuses": "Algunha das túas publicacións foron eliminadas.",
  "notification.moderation_warning.action_disable": "A túa conta foi desactivada.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Algunha das túas publicacións foron marcadas como sensibles.",
  "notification.moderation_warning.action_none": "A túa conta recibeu unha advertencia da moderación.",
  "notification.moderation_warning.action_sensitive": "De agora en diante as túas publicacións van ser marcadas como sensibles.",
  "notification.moderation_warning.action_silence": "A túa conta foi limitada.",
  "notification.moderation_warning.action_suspend": "A túa conta foi suspendida.",
  "notification.own_poll": "A túa enquisa rematou",
  "notification.poll": "Rematou a enquisa na que votaches",
  "notification.quoted_update": "{name} editou unha publicación que citaches",
  "notification.reblog": "{name} compartiu a túa publicación",
  "notification.reblog.name_and_others_with_link": "{name} e <a>{count, plural, one {# máis} other {# máis}}</a> promoveron a túa publicación",
  "notification.relationships_severance_event": "Relacións perdidas con {name}",
  "notification.relationships_severance_event.account_suspension": "A administración de {from} suspendeu a {target}, o que significa que xa non vas recibir actualizacións de esa conta ou interactuar con ela.",
  "notification.relationships_severance_event.domain_block": "A administración de {from} bloqueou a {target}, que inclúe a {followersCount} das túas seguidoras e a {followingCount, plural, one {# conta} other {# contas}} que sigues.",
  "notification.relationships_severance_event.learn_more": "Saber máis",
  "notification.relationships_severance_event.user_domain_block": "Bloqueaches a {target}, eliminando a {followersCount} das túas seguidoras e a {followingCount, plural, one {# conta} other {# contas}} que sigues.",
  "notification.status": "{name} publicou",
  "notification.update": "{name} editou unha publicación",
  "notification_requests.accept": "Aceptar",
  "notification_requests.accept_multiple": "{count, plural, one {Aceptar # solicitude…} other {Aceptar # solicitudes…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Aceptar solicitude} other {Aceptar solicitudes}}",
  "notification_requests.confirm_accept_multiple.message": "Vas aceptar {count, plural, one {unha solicitude de notificación} other {# solicitudes de notificación}}. Tes certeza de querer aceptar?",
  "notification_requests.confirm_accept_multiple.title": "Aceptar solicitudes de notificación?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Rexeitar solicitude} other {Rexeitar solicitudes}}",
  "notification_requests.confirm_dismiss_multiple.message": "Vas rexeitar {count, plural, one {unha solicitude de notificación} other {# solicitudes de notificación}}. Non poderás volver acceder fácilmente a {count, plural, one {ela} other {elas}}. Tes certeza de querer rexeitar?",
  "notification_requests.confirm_dismiss_multiple.title": "Rexeitar solicitudes de notificación?",
  "notification_requests.dismiss": "Desbotar",
  "notification_requests.dismiss_multiple": "{count, plural, one {Rexeitar # solicitude…} other {Rexeitar # solicitudes…}}",
  "notification_requests.edit_selection": "Editar",
  "notification_requests.exit_selection": "Feito",
  "notification_requests.explainer_for_limited_account": "Filtráronse as notificacións desta conta porque a conta ten limitacións impostas pola moderación.",
  "notification_requests.explainer_for_limited_remote_account": "Filtráronse as notificacións desta conta porque a conta ou o seu servidor teñen limitacións impostas pola moderación.",
  "notification_requests.maximize": "Maximizar",
  "notification_requests.minimize_banner": "Minimizar o anuncio de notificacións filtradas",
  "notification_requests.notifications_from": "Notificacións de {name}",
  "notification_requests.title": "Notificacións filtradas",
  "notification_requests.view": "Ver notificacións",
  "notifications.clear": "Limpar notificacións",
  "notifications.clear_confirmation": "Tes a certeza de querer limpar de xeito permanente todas as túas notificacións?",
  "notifications.clear_title": "Limpar as notificacións?",
  "notifications.column_settings.admin.report": "Novas denuncias:",
  "notifications.column_settings.admin.sign_up": "Novas usuarias:",
  "notifications.column_settings.alert": "Notificacións de escritorio",
  "notifications.column_settings.favourite": "Favoritas:",
  "notifications.column_settings.filter_bar.advanced": "Mostrar todas as categorías",
  "notifications.column_settings.filter_bar.category": "Barra de filtrado rápido",
  "notifications.column_settings.follow": "Novas seguidoras:",
  "notifications.column_settings.follow_request": "Novas peticións de seguimento:",
  "notifications.column_settings.group": "Agrupar",
  "notifications.column_settings.mention": "Mencións:",
  "notifications.column_settings.poll": "Resultados da enquisa:",
  "notifications.column_settings.push": "Notificacións emerxentes",
  "notifications.column_settings.quote": "Citacións:",
  "notifications.column_settings.reblog": "Promocións:",
  "notifications.column_settings.show": "Amosar en columna",
  "notifications.column_settings.sound": "Reproducir son",
  "notifications.column_settings.status": "Novas publicacións:",
  "notifications.column_settings.unread_notifications.category": "Notificacións non lidas",
  "notifications.column_settings.unread_notifications.highlight": "Resaltar notificacións non lidas",
  "notifications.column_settings.update": "Edicións:",
  "notifications.filter.all": "Todo",
  "notifications.filter.boosts": "Compartidos",
  "notifications.filter.favourites": "Favoritas",
  "notifications.filter.follows": "Seguimentos",
  "notifications.filter.mentions": "Mencións",
  "notifications.filter.polls": "Resultados da enquisa",
  "notifications.filter.statuses": "Actualizacións de persoas que segues",
  "notifications.grant_permission": "Conceder permiso.",
  "notifications.group": "{count} notificacións",
  "notifications.mark_as_read": "Marcar todas as notificacións como lidas",
  "notifications.permission_denied": "Non se activaron as notificacións de escritorio porque se denegou o permiso",
  "notifications.permission_denied_alert": "Non se poden activar as notificacións de escritorio, xa que o permiso para o navegador foi denegado previamente",
  "notifications.permission_required": "As notificacións de escritorio non están dispoñibles porque non se concedeu o permiso necesario.",
  "notifications.policy.accept": "Aceptar",
  "notifications.policy.accept_hint": "Ver nas notificacións",
  "notifications.policy.drop": "Ignorar",
  "notifications.policy.drop_hint": "Esquecer isto, non volver a velo",
  "notifications.policy.filter": "Filtrar",
  "notifications.policy.filter_hint": "Enviar á caixa de notificacións filtradas",
  "notifications.policy.filter_limited_accounts_hint": "Limitada pola moderación do servidor",
  "notifications.policy.filter_limited_accounts_title": "Contas moderadas",
  "notifications.policy.filter_new_accounts.hint": "Creadas desde {days, plural, one {onte} other {fai # días}}",
  "notifications.policy.filter_new_accounts_title": "Novas contas",
  "notifications.policy.filter_not_followers_hint": "Inclúe a persoas que te seguen desde fai menos de {days, plural, one {1 día} other {# días}}",
  "notifications.policy.filter_not_followers_title": "Persoas que non te seguen",
  "notifications.policy.filter_not_following_hint": "Ata que as autorices",
  "notifications.policy.filter_not_following_title": "Persoas que ti non segues",
  "notifications.policy.filter_private_mentions_hint": "Filtradas a non ser que sexa unha resposta á túa propia mención ou se ti segues á remitente",
  "notifications.policy.filter_private_mentions_title": "Mencións privadas non solicitadas",
  "notifications.policy.title": "Xestionar as notificacións de…",
  "notifications_permission_banner.enable": "Activar notificacións de escritorio",
  "notifications_permission_banner.how_to_control": "Activa as notificacións de escritorio para recibir notificacións mentras Mastodon non está aberto. Podes controlar de xeito preciso o tipo de interaccións que crean as notificacións de escritorio a través da {icon} superior unha vez están activadas.",
  "notifications_permission_banner.title": "Non perder nada",
  "onboarding.follows.back": "Volver",
  "onboarding.follows.empty": "Desgraciadamente agora mesmo non hai nada que mostrar. Podes intentalo coa busca ou na páxina descubrir para atopar persoas ás que seguir, ou intentalo máis tarde.",
  "onboarding.follows.next": "Seguinte: Configura o teu perfil",
  "onboarding.follows.search": "Buscar",
  "onboarding.follows.title": "Comeza seguindo algunhas persoas",
  "onboarding.profile.discoverable": "Que o meu perfil se poida atopar",
  "onboarding.profile.discoverable_hint": "Cando elixes que poidan atoparte en Mastodon as túas publicacións aparecerán nos resultados das buscas e nos temas en voga, e o teu perfil podería ser suxerido para seguimento a persoas con intereses semellantes aos teus.",
  "onboarding.profile.display_name": "Nome público",
  "onboarding.profile.display_name_hint": "O teu nome completo ou un nome divertido…",
  "onboarding.profile.finish": "Finalizar",
  "onboarding.profile.note": "Sobre ti",
  "onboarding.profile.note_hint": "Podes @mencionar a outras persoas ou usar #cancelos…",
  "onboarding.profile.title": "Configuración do perfil",
  "onboarding.profile.upload_avatar": "Subir imaxe do perfil",
  "onboarding.profile.upload_header": "Subir cabeceira para o perfil",
  "password_confirmation.exceeds_maxlength": "A lonxitude do contrasinal de confirmación excede o máximo permitido",
  "password_confirmation.mismatching": "O contrasinal de confirmación non concorda",
  "picture_in_picture.restore": "Devolver",
  "poll.closed": "Pechado",
  "poll.refresh": "Actualizar",
  "poll.reveal": "Ver resultados",
  "poll.total_people": "{count, plural,one {# persoa} other {# persoas}}",
  "poll.total_votes": "{count, plural, one {# voto} other {# votos}}",
  "poll.vote": "Votar",
  "poll.voted": "Votaches por esta opción",
  "poll.votes": "{votes, plural, one {# voto} other {# votos}}",
  "poll_button.add_poll": "Engadir unha enquisa",
  "poll_button.remove_poll": "Eliminar enquisa",
  "privacy.change": "Axustar privacidade",
  "privacy.direct.long": "Todas as mencionadas na publicación",
  "privacy.direct.short": "Mención privada",
  "privacy.private.long": "Só quen te segue",
  "privacy.private.short": "Seguidoras",
  "privacy.public.long": "Para todas dentro e fóra de Mastodon",
  "privacy.public.short": "Público",
  "privacy.quote.anyone": "{visibility}, permítese citar",
  "privacy.quote.disabled": "{visibility}, citas desactivadas",
  "privacy.quote.limited": "{visibility}, citas limitadas",
  "privacy.unlisted.additional": "Do mesmo xeito que público, menos que a publicación non aparecerá nas cronoloxías en directo ou nos cancelos, en descubrir ou nas buscas de Mastodon, incluso se estivese establecido nas opcións xerais da conta.",
  "privacy.unlisted.long": "Non aparece nos resultados de buscas en Mastodon, nas tendencias e cronoloxías públicas",
  "privacy.unlisted.short": "Pública limitada",
  "privacy_policy.last_updated": "Actualizado por última vez no {date}",
  "privacy_policy.title": "Política de Privacidade",
  "quote_error.edit": "Non se poden engadir citas ao editar unha publicación.",
  "quote_error.poll": "Non se permite citar as enquisas.",
  "quote_error.private_mentions": "As citas non están permitidas nas mencións directas.",
  "quote_error.quote": "Só se permite citar unha vez.",
  "quote_error.unauthorized": "Non tes permiso para citar esta publicación.",
  "quote_error.upload": "As citas non están permitidas para anexos multimedia.",
  "recommended": "Aconsellable",
  "refresh": "Actualizar",
  "regeneration_indicator.please_stand_by": "Por favor, agarda.",
  "regeneration_indicator.preparing_your_home_feed": "Creando a túa cronoloxía…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "hai {number, plural, one {# día} other {# días}}",
  "relative_time.full.hours": "hai {number, plural, one {# hora} other {# horas}}",
  "relative_time.full.just_now": "xusto agora",
  "relative_time.full.minutes": "hai {number, plural, one {# minuto} other {# minutos}}",
  "relative_time.full.seconds": "fai {number, plural, one {# segundo} other {# segundos}}",
  "relative_time.hours": "{number}h",
  "relative_time.just_now": "agora",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "hoxe",
  "remove_quote_hint.button_label": "Entendido",
  "remove_quote_hint.message": "Pódelo facer desde o {icon} menú de opcións.",
  "remove_quote_hint.title": "Queres eliminar a publicación citada?",
  "reply_indicator.attachments": "{count, plural, one {# adxunto} other {# adxuntos}}",
  "reply_indicator.cancel": "Desbotar",
  "reply_indicator.poll": "Enquisa",
  "report.block": "Bloquear",
  "report.block_explanation": "Non vas ver as súas publicacións. Nin verá as túas publicacións nin poderá seguirte. Poderá comprobar que as bloqueaches.",
  "report.categories.legal": "Legal",
  "report.categories.other": "Outro",
  "report.categories.spam": "Spam",
  "report.categories.violation": "O contido viola unha ou máis regras do servidor",
  "report.category.subtitle": "Elixe a mellor coincidencia",
  "report.category.title": "Cóntanos o problema con {type}",
  "report.category.title_account": "perfil",
  "report.category.title_status": "publicación",
  "report.close": "Feito",
  "report.collection_comment": "Por que queres denunciar esta colección?",
  "report.comment.title": "Hai algo máis que creas debamos saber?",
  "report.forward": "Reenviar a {target}",
  "report.forward_hint": "A conta é doutro servidor. Enviar unha copia anónima da denuncia aló tamén?",
  "report.mute": "Acalar",
  "report.mute_explanation": "Non verás as súas publicacións. Poderá seguirte e ver as túas publicacións e non saberá que a silenciaches.",
  "report.next": "Seguinte",
  "report.placeholder": "Comentarios adicionais",
  "report.reasons.dislike": "Non me gusta",
  "report.reasons.dislike_description": "Non é algo que queiras ver",
  "report.reasons.legal": "É ilegal",
  "report.reasons.legal_description": "Cres que atenta contra as leis do país do teu pais ou servidor",
  "report.reasons.other": "É outra cousa",
  "report.reasons.other_description": "O problema non cae dentro de outras categorías",
  "report.reasons.spam": "É spam",
  "report.reasons.spam_description": "Ligazóns perigosas, relacións falsas, ou respostas repetitivas",
  "report.reasons.violation": "Viola as regras do servidor",
  "report.reasons.violation_description": "Décheste conta de que quebra unhas normas en concreto",
  "report.rules.subtitle": "Elixe todo o que sexa de aplicación",
  "report.rules.title": "Que regras foron incumpridas?",
  "report.statuses.subtitle": "Elixe todo o que corresponda",
  "report.statuses.title": "Hai algunha publicación que apoie esta denuncia?",
  "report.submission_error": "Non se puido enviar a denuncia",
  "report.submission_error_details": "Comproba a conexión á rede e volve a intentalo máis tarde.",
  "report.submit": "Enviar",
  "report.target": "Denunciar a {target}",
  "report.thanks.take_action": "Aquí tes unhas opcións para controlar o que ves en Mastodon:",
  "report.thanks.take_action_actionable": "Mentras revisamos isto, podes tomar accións contra @{name}:",
  "report.thanks.title": "Non queres ver isto?",
  "report.thanks.title_actionable": "Grazas pola denuncia, investigarémola.",
  "report.unfollow": "Non seguir a @{name}",
  "report.unfollow_explanation": "Estás a seguir esta conta. Deixar de ver as súas publicacións na túa cronoloxía, non seguila.",
  "report_notification.attached_statuses": "Achegou {count, plural, one {{count} publicación} other {{count} publicacións}}",
  "report_notification.categories.legal": "Legal",
  "report_notification.categories.legal_sentence": "contido ilegal",
  "report_notification.categories.other": "Outro",
  "report_notification.categories.other_sentence": "outra",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.categories.violation": "Faltou ás regras",
  "report_notification.categories.violation_sentence": "violación das regras",
  "report_notification.open": "Abrir a denuncia",
  "search.clear": "Limpar a busca",
  "search.no_recent_searches": "Non hai buscas recentes",
  "search.placeholder": "Procurar",
  "search.quick_action.account_search": "Perfís coincidentes {x}",
  "search.quick_action.go_to_account": "Ir ao perfil {x}",
  "search.quick_action.go_to_hashtag": "Ir ao cancelo {x}",
  "search.quick_action.open_url": "Abrir URL en Mastodon",
  "search.quick_action.status_search": "Publicacións coincidentes {x}",
  "search.search_or_paste": "Busca ou insire URL",
  "search_popout.full_text_search_disabled_message": "Non está dispoñible en {domain}.",
  "search_popout.full_text_search_logged_out_message": "Só dispoñible ao iniciar sesión.",
  "search_popout.language_code": "Código ISO do idioma",
  "search_popout.options": "Opcións de busca",
  "search_popout.quick_actions": "Accións rápidas",
  "search_popout.recent": "Buscas recentes",
  "search_popout.specific_date": "data específica",
  "search_popout.user": "usuaria",
  "search_results.accounts": "Perfís",
  "search_results.all": "Todo",
  "search_results.hashtags": "Cancelos",
  "search_results.no_results": "Sen resultados.",
  "search_results.no_search_yet": "Intenta buscando publicacións, perfís ou cancelos.",
  "search_results.see_all": "Ver todo",
  "search_results.statuses": "Publicacións",
  "search_results.title": "Resultados para «{q}»",
  "server_banner.about_active_users": "Persoas que usaron este servidor nos últimos 30 días (Usuarias Activas Mensuais)",
  "server_banner.active_users": "usuarias activas",
  "server_banner.administered_by": "Administrada por:",
  "server_banner.is_one_of_many": "{domain} é un dos moitos servidores Mastodon independentes que podes usar para participar do Fediverso.",
  "server_banner.more_about_this_server": "Máis info sobre este servidor",
  "server_banner.server_stats": "Estatísticas do servidor:",
  "sign_in_banner.create_account": "Crear conta",
  "sign_in_banner.follow_anyone": "Sigue a quen queiras no Fediverso e le as publicacións en orde cronolóxica. Sen algoritmos, publicidade nin titulares enganosos.",
  "sign_in_banner.mastodon_is": "Mastodon é o mellor xeito de estar ao día do que acontece.",
  "sign_in_banner.sign_in": "Iniciar sesión",
  "sign_in_banner.sso_redirect": "Acceder ou Crear conta",
  "skip_links.hotkey": "<span>Atallo</span> {hotkey}",
  "skip_links.skip_to_content": "Ir ao contido principal",
  "skip_links.skip_to_navigation": "Ir ao menú principal",
  "status.admin_account": "Abrir interface de moderación para @{name}",
  "status.admin_domain": "Abrir interface de moderación para {domain}",
  "status.admin_status": "Abrir esta publicación na interface de moderación",
  "status.all_disabled": "As promocións e citas están desactivadas",
  "status.block": "Bloquear a @{name}",
  "status.bookmark": "Marcar",
  "status.cancel_reblog_private": "Desfacer compartido",
  "status.cannot_quote": "Non tes permiso para citar esta publicación",
  "status.cannot_reblog": "Esta publicación non pode ser promovida",
  "status.contains_quote": "Contén unha cita",
  "status.context.loading": "Cargando máis respostas",
  "status.context.loading_error": "Non se puideron mostrar novas respostas",
  "status.context.loading_success": "Móstranse novas respostas",
  "status.context.more_replies_found": "Existen máis respostas",
  "status.context.retry": "Volver tentar",
  "status.context.show": "Mostrar",
  "status.continued_thread": "Continua co fío",
  "status.copy": "Copiar ligazón á publicación",
  "status.delete": "Eliminar",
  "status.delete.success": "Publicación eliminada",
  "status.detailed_status": "Vista detallada da conversa",
  "status.direct": "Mencionar de xeito privado a @{name}",
  "status.direct_indicator": "Mención privada",
  "status.edit": "Editar",
  "status.edited": "Última edición {date}",
  "status.edited_x_times": "Editado {count, plural, one {{count} vez} other {{count} veces}}",
  "status.embed": "O código a incluír",
  "status.favourite": "Favorecer",
  "status.favourites_count": "{count, plural, one {{counter} favorecemento} other {{counter} favorecementos}}",
  "status.filter": "Filtrar esta publicación",
  "status.history.created": "{name} creouno o {date}",
  "status.history.edited": "{name} editouno o {date}",
  "status.load_more": "Cargar máis",
  "status.media.open": "Preme para abrir",
  "status.media.show": "Preme para ver",
  "status.media_hidden": "Contido multimedia agochado",
  "status.mention": "Mencionar @{name}",
  "status.more": "Máis",
  "status.mute": "Silenciar @{name}",
  "status.mute_conversation": "Silenciar conversa",
  "status.open": "Estender esta publicación",
  "status.pin": "Fixar no perfil",
  "status.quote": "Citar",
  "status.quote.cancel": "Cancelar a cita",
  "status.quote_error.blocked_account_hint.title": "A publicación está oculta porque bloqueaches a @{name}.",
  "status.quote_error.blocked_domain_hint.title": "A publicación está oculta porque bloqueaches {domain}.",
  "status.quote_error.filtered": "Oculto debido a un dos teus filtros",
  "status.quote_error.limited_account_hint.action": "Mostrar igualmente",
  "status.quote_error.limited_account_hint.title": "A moderación de {domain} ocultou esta conta.",
  "status.quote_error.muted_account_hint.title": "A publicación está oculta porque silenciaches a @{name}.",
  "status.quote_error.not_available": "Publicación non dispoñible",
  "status.quote_error.pending_approval": "Publicación pendente",
  "status.quote_error.pending_approval_popout.body": "En Mastodon podes establecer se permites que te citen. Esta publicación queda pendente á espera de que a persoa autora orixinal o autorice.",
  "status.quote_error.revoked": "Publicación retirada pola autora",
  "status.quote_followers_only": "Só as seguidoras poden citar esta publicación",
  "status.quote_manual_review": "A autora revisará manualmente",
  "status.quote_noun": "Cita",
  "status.quote_policy_change": "Cambia quen pode citarte",
  "status.quote_post_author": "Citou unha publicación de @{name}",
  "status.quote_private": "As publicacións privadas non se poden citar",
  "status.quotes.empty": "Aínda ninguén citou esta publicación. Cando alguén o faga aparecerá aquí.",
  "status.quotes.local_other_disclaimer": "Non se mostrarán as citas rexeitadas pola autora.",
  "status.quotes.remote_other_disclaimer": "Só se garante que se mostren as citas do dominio {domain}. Non se mostrarán as citas rexeitadas pola persoa autora.",
  "status.quotes_count": "{count, plural, one {{counter} cita} other {{counter} citas}}",
  "status.read_more": "Ler máis",
  "status.reblog": "Promover",
  "status.reblog_or_quote": "Promover ou citar",
  "status.reblog_private": "Volver a compartir coas túas seguidoras",
  "status.reblogged_by": "{name} promoveu",
  "status.reblogs.empty": "Aínda ninguén promoveu esta publicación. Cando alguén o faga, amosarase aquí.",
  "status.reblogs_count": "{count, plural, one {{counter} promoción} other {{counter} promocións}}",
  "status.redraft": "Eliminar e reescribir",
  "status.remove_bookmark": "Eliminar marcador",
  "status.remove_favourite": "Retirar das favoritas",
  "status.remove_quote": "Retirar",
  "status.replied_in_thread": "Respondeu nun fío",
  "status.replied_to": "Respondeu a {name}",
  "status.reply": "Responder",
  "status.replyAll": "Responder ao tema",
  "status.report": "Denunciar @{name}",
  "status.request_quote": "Solicitar a citación",
  "status.revoke_quote": "Retirar a miña publicación da cita de @{name}",
  "status.sensitive_warning": "Contido sensíbel",
  "status.share": "Compartir",
  "status.show_less_all": "Amosar menos para todos",
  "status.show_more_all": "Amosar máis para todos",
  "status.show_original": "Mostrar o orixinal",
  "status.title.with_attachments": "{user} publicou {attachmentCount, plural, one {un anexo} other {{attachmentCount} anexos}}",
  "status.translate": "Traducir",
  "status.translated_from_with": "Traducido do {lang} usando {provider}",
  "status.uncached_media_warning": "A vista previa non está dispoñíble",
  "status.unmute_conversation": "Deixar de silenciar conversa",
  "status.unpin": "Non fixar no perfil",
  "subscribed_languages.lead": "Ao facer cambios só as publicacións nos idiomas seleccionados aparecerán nas túas cronoloxías. Non elixas ningún para poder ver publicacións en tódolos idiomas.",
  "subscribed_languages.save": "Gardar cambios",
  "subscribed_languages.target": "Cambiar a subscrición a idiomas para {target}",
  "tabs_bar.home": "Inicio",
  "tabs_bar.menu": "Menú",
  "tabs_bar.notifications": "Notificacións",
  "tabs_bar.publish": "Nova publicación",
  "tabs_bar.search": "Buscar",
  "tag.remove": "Retirar",
  "terms_of_service.effective_as_of": "Con efecto desde o {date}",
  "terms_of_service.title": "Condicións do Servizo",
  "terms_of_service.upcoming_changes_on": "Cambios por vir o {date}",
  "time_remaining.days": "Remata en {number, plural, one {# día} other {# días}}",
  "time_remaining.hours": "Remata en {number, plural, one {# hora} other {# horas}}",
  "time_remaining.minutes": "Remata en {number, plural, one {# minuto} other {# minutos}}",
  "time_remaining.moments": "A piques de rematar",
  "time_remaining.seconds": "Remata en {number, plural, one {# segundo} other {# segundos}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} persoa} other {{counter} persoas}} {days, plural, one {no último día} other {nos {days} últimos días}}",
  "trends.trending_now": "Temas populares",
  "ui.beforeunload": "O borrador perderase se saes de Mastodon.",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Arrastra e solta para subir",
  "upload_button.label": "Engadir imaxes, un vídeo ou ficheiro de audio",
  "upload_error.limit": "Límite máximo do ficheiro a subir excedido.",
  "upload_error.poll": "Non se poden subir ficheiros nas enquisas.",
  "upload_error.quote": "Non se permite subir ficheiros ao citar.",
  "upload_form.drag_and_drop.instructions": "Preme en Espazo ou Enter para escoller un anexo multimedia. Ao arrastrar usa as teclas de frecha para mover o anexo en todas direccións.Preme Espazo ou Enter outra vez para soltalo na súa nova posición, ou preme Escape para desbotar.",
  "upload_form.drag_and_drop.on_drag_cancel": "Cancelouse o movemento. O anexo {item} soltouse.",
  "upload_form.drag_and_drop.on_drag_end": "Soltouse o anexo multimedia {item}.",
  "upload_form.drag_and_drop.on_drag_over": "Moveuse o anexo multimedia {item}.",
  "upload_form.drag_and_drop.on_drag_start": "Escolleuse o anexo multimedia {item}.",
  "upload_form.edit": "Editar",
  "upload_progress.label": "Estase a subir...",
  "upload_progress.processing": "Procesando…",
  "username.taken": "O identificador xa está pillado. Inténtao con outro",
  "video.close": "Pechar vídeo",
  "video.download": "Baixar ficheiro",
  "video.exit_fullscreen": "Saír da pantalla completa",
  "video.expand": "Estender o vídeo",
  "video.fullscreen": "Pantalla completa",
  "video.hide": "Agochar vídeo",
  "video.mute": "Acalar",
  "video.pause": "Deter",
  "video.play": "Reproducir",
  "video.skip_backward": "Retroceder",
  "video.skip_forward": "Avanzar",
  "video.unmute": "Non silenciar",
  "video.volume_down": "Baixar volume",
  "video.volume_up": "Subir volume",
  "visibility_modal.button_title": "Establece a visibilidade",
  "visibility_modal.direct_quote_warning.text": "Se gardas os axustes actuais a cita incluída vaise converter nunha ligazón.",
  "visibility_modal.direct_quote_warning.title": "As citas non se poden incluír nas mencións privadas",
  "visibility_modal.header": "Visibilidade e interaccións",
  "visibility_modal.helper.direct_quoting": "As mencións privadas creadas con Mastodon non poden ser citadas.",
  "visibility_modal.helper.privacy_editing": "Non se pode cambiar a visibilidade unha vez foi publicada.",
  "visibility_modal.helper.privacy_private_self_quote": "Non se poden facer públicas as auto-citas de publicacións privadas.",
  "visibility_modal.helper.private_quoting": "As publicacións só para seguidoras creadas con Mastodon non poden ser citadas.",
  "visibility_modal.helper.unlisted_quoting": "Cando alguén te cite, a súa publicación non aparecerá nas cronoloxías de popularidade.",
  "visibility_modal.instructions": "Establece quen pode interactuar con esta publicación. Tamén podes aplicar os axustes ás publicacións futuras en <link>Preferencias > Por defecto ao publicar</link>.",
  "visibility_modal.privacy_label": "Visibilidade",
  "visibility_modal.quote_followers": "Só para seguidoras",
  "visibility_modal.quote_label": "Quen pode citar",
  "visibility_modal.quote_nobody": "Só eu",
  "visibility_modal.quote_public": "Calquera",
  "visibility_modal.save": "Gardar"
}
